/* ⚠ This file is requested by more than one section — the hero, the
   bundle band and Complete the Setup all carry a <script src> for it.
   Identical URLs are fetched once and EXECUTED once per tag, so on a
   Product Story every listener below was bound twice and every element
   this file builds was built twice: the owner found it as two "Read the
   whole reason" chevrons under one paragraph.

   A section may not assume another section is on the page, so the tags
   stay and the file runs once. The whole body is inside this guard; the
   only thing outside it is the flag. */
if (!window.__nxProductJs) {
window.__nxProductJs = true;

/* The currency sign of the market the visitor is in (2026-11-02, UK): Shopify prints the presentment
   currency in Shopify.currency.active; Liquid's money filter already uses it, this keeps the script in step. */
var SYM = ({ GBP: '£', EUR: '€' })[(window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || ''] || '$';

/* Every add in the store goes through nx-quick-add.js's `window.nxCart`,
   which paints the theme's own drawer from the Section Rendering API and
   slides it in. Read at call time rather than captured, because both files
   are deferred and their order is a section-tag detail; if it is somehow
   absent the add still happens and the reader still gets the cart page. */
/* Work the first screen does not depend on waits for a gap in the main thread: a reader who taps in
   the first seconds should not be queued behind us. On 2026-09-16 taps during load waited up to
   0.7 s on a phone-grade CPU, and this file held 177 ms of that. `requestIdleCallback` is missing on
   older iOS, so a short timer stands in — the point is only to be after the first paint. */
function nxIdle(fn, timeout) {
  if (window.requestIdleCallback) return window.requestIdleCallback(fn, { timeout: timeout || 800 });
  return setTimeout(fn, 120);
}

function cartAdd(items, message) {
  if (window.nxCart) return window.nxCart.add(items, message);
  return fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify({ items: items })
  }).then(function (response) {
    if (!response.ok) throw new Error('cart add failed');
    window.location.href = '/cart';
  });
}

document.querySelectorAll('[id^="ProductHero-"]').forEach(function (hero) {
  var form = hero.querySelector('.nx-product-hero__form');
  var variantIdInput = hero.querySelector('[data-nx-variant-id]');
  var sectionKey = hero.id.replace('ProductHero-', '');
  var variantsScript =
    hero.querySelector('[data-nx-variants]') ||
    document.querySelector('[data-nx-variants="' + sectionKey + '"]');
  var priceEl = hero.querySelector('.nx-price__current');
  var stockLine = hero.querySelector('[data-nx-stock-line]');
  var pillsWrap = hero.querySelector('[data-nx-option-pills]');
  var stickyBar = hero.querySelector('[data-nx-sticky-bar]');
  var stickyPrice = hero.querySelector('[data-nx-sticky-price]');
  var atcButtons = hero.querySelectorAll('.nx-buy-buttons__atc');

  var variants = variantsScript ? JSON.parse(variantsScript.textContent) : [];

  function findVariantById(id) {
    for (var i = 0; i < variants.length; i++) {
      if (String(variants[i].id) === String(id)) return variants[i];
    }
    return null;
  }

  var currentVariant = variantIdInput ? findVariantById(variantIdInput.value) : null;
  var currentOptions = currentVariant ? currentVariant.options.slice() : [];

  function updateSticky() {
    if (stickyPrice && currentVariant) stickyPrice.textContent = currentVariant.price;
  }

  function setMainImage(src) {
    if (!mainImage || !src) return;
    // The main <img> carries a responsive srcset/sizes; without clearing them
    // the browser keeps painting the srcset candidate and ignores a new .src.
    mainImage.srcset = '';
    mainImage.removeAttribute('sizes');
    mainImage.src = src;
  }

  function swapMedia(variant) {
    if (!variant) return;
    var mediaId = variant.featured_id ? String(variant.featured_id) : '';
    var activePill = pillsWrap && pillsWrap.querySelector('.nx-pill--active');
    var valueText = activePill ? String(activePill.dataset.value || '').toLowerCase() : '';

    // The alt-text search is a FALLBACK for products whose variants have no media
    // bound to them. When a variant does have one, its id is exact and must be the
    // only test — otherwise a value that is a prefix of another value matches both,
    // and the loop below keeps the LAST match. The Triptych shipped four versions
    // named Graphite, Ink, Graphite with Case and Ink with Case: picking the $39
    // Graphite lit up the with-case thumb too and put the $49 photo, case and all,
    // in the main frame. Caught on the preview, 2026-08-04.
    function matchEl(el) {
      if (mediaId) return String(el.dataset.mediaId) === mediaId;
      if (valueText && el.dataset.mediaAlt && el.dataset.mediaAlt.toLowerCase().indexOf(valueText) !== -1) return true;
      return false;
    }

    var targetThumb = null;
    hero.querySelectorAll('[data-nx-thumb]').forEach(function (thumb) {
      if (matchEl(thumb)) targetThumb = thumb;
    });
    /* Through the thumb's own path, so a film that was on show is put away and the pager follows. */
    if (targetThumb) showThumb(targetThumb);
    else {
      hero.querySelectorAll('[data-nx-thumb]').forEach(function (t) {
        t.classList.remove('nx-product-hero__thumb--active');
      });
      if (variant.featured_src) setMainImage(variant.featured_src);
    }

    var mScroller = hero.querySelector('.nx-product-hero__scroller');
    if (mScroller) {
      var items = mScroller.querySelectorAll('.nx-product-hero__scroll-item');
      for (var i = 0; i < items.length; i++) {
        if (matchEl(items[i])) {
          /* ⚠ Smooth only for a neighbour. Since the gallery carries twelve frames and every
             variant's own frame is appended after them (2026-09-20), a colour can sit thirteen
             frames away: a smooth scroll then slides through a dozen photographs for more than a
             second, and the tap reads as broken until it lands. Anything past two frames jumps. */
          var far = Math.abs(i - Math.round(mScroller.scrollLeft / mScroller.clientWidth)) > 2;
          mScroller.scrollTo({ left: mScroller.clientWidth * i, behavior: far ? 'auto' : 'smooth' });
          break;
        }
      }
      /* ⚠ This scrolls the GALLERY, never the PAGE. The line above moves the
         horizontal scroller to the new colour's frame, which is what makes the
         hero change on a phone — it must stay.

         What was here and is gone (2026-08-15, owner): a vertical
         `scrollIntoView` on the mobile gallery, which fired on every colour and
         size tap and dragged the page back up to the photograph. It was added so
         the new colour would be seen, and it answered that question by taking
         the reader away from the one they were actually working on — the pills
         sit just under Add to Cart, so choosing a size threw the button off
         screen mid-purchase. Tapping a swatch is a step TOWARDS buying, and the
         page must not move under a thumb that is on its way to the button. The
         frame still changes; the reader decides when to look at it. */
    }
  }

  function applyVariant(variant) {
    if (!variant) return;
    currentVariant = variant;
    if (variantIdInput) variantIdInput.value = variant.id;
    if (priceEl) priceEl.textContent = variant.price;
    if (stockLine) stockLine.textContent = variant.available ? '' : 'Sold out';
    atcButtons.forEach(function (button) {
      button.disabled = !variant.available;
      button.textContent = variant.available ? 'Add to Cart' : 'Sold Out';
    });
    if (!unitsLock) units = null;
    if (paintChips) paintChips();
    swapMedia(variant);
    updateSticky();
  }

  /* ⚠ EVERY option row, not the first. This bound with `querySelector` — one
     row — which was correct for as long as every product had one option, and
     silently wrong the moment The Triptych's `Version` became Version × Color:
     the colour row rendered and nothing listened to it, so clicking a colour
     did nothing at all. Each row owns its own option position and clears only
     its own siblings; choosing a colour must not unchoose the version. */
  hero.querySelectorAll('[data-nx-option-pills]').forEach(function (wrap) {
    var optionPosition = parseInt(wrap.dataset.optionPosition, 10) - 1;
    var group = wrap.closest('.nx-product-hero__option');
    var selectedLabel = group ? group.querySelector('[data-nx-selected-option]') : null;

    wrap.querySelectorAll('[data-nx-pill]').forEach(function (pill) {
      pill.addEventListener('click', function () {
        wrap.querySelectorAll('[data-nx-pill]').forEach(function (p) {
          p.classList.remove('nx-pill--active');
        });
        pill.classList.add('nx-pill--active');
        if (selectedLabel) selectedLabel.textContent = pill.dataset.value;

        var desiredOptions = currentOptions.slice();
        desiredOptions[optionPosition] = pill.dataset.value;

        var match = variants.find(function (variant) {
          return variant.options.every(function (value, index) {
            return value === desiredOptions[index];
          });
        });

        if (match) {
          currentOptions = desiredOptions;
          applyVariant(match);
        }
      });
    });
  });

  updateSticky();

  var qtyInput = hero.querySelector('[data-nx-qty-input]');
  var qtyDecrease = hero.querySelector('[data-nx-qty-decrease]');
  var qtyIncrease = hero.querySelector('[data-nx-qty-increase]');

  if (qtyInput && qtyDecrease && qtyIncrease) {
    qtyDecrease.addEventListener('click', function () {
      var value = Math.max(1, (parseInt(qtyInput.value, 10) || 1) - 1);
      qtyInput.value = value;
    });
    qtyIncrease.addEventListener('click', function () {
      var value = (parseInt(qtyInput.value, 10) || 1) + 1;
      qtyInput.value = value;
    });
  }

  /* THE 1 / 2 / 3 CHIPS (owner, 2026-09-29, on trial — sections/nx-product-hero.liquid). The same chips
     are printed twice, one set for a phone and one for a desktop, so a choice is painted in both. The
     choice IS the quantity the form posts; the button then says what it will add and for how much —
     "Add 2 to Cart · $142.40" — because a chip that changes the basket must say so where the tap lands.
     Prices come from the variant in cents and each chip's own rate (nx-ladder's), never from a table here. */
  var chipSets = hero.querySelectorAll('[data-nx-chips]');
  var chosen = 1;
  var paintChips = null;
  if (chipSets.length) {
    var chipQty = hero.querySelector('[data-nx-qty-input]');
    var mainAtc = form ? form.querySelector('.nx-buy-buttons__atc') : null;
    var money = function (c) { return SYM + (c % 100 ? (c / 100).toFixed(2) : String(c / 100)); };
    /* small cents, as snippets/nx-money.liquid prints them (owner, 2026-09-30) */
    var moneyHTML = function (c) { var cc = c % 100; return SYM + (c - cc) / 100 + (cc ? '<sup class="nx-cents">' + (cc < 10 ? '0' : '') + cc + '</sup>' : ''); };
    paintChips = function () {
      var cents = currentVariant && currentVariant.cents;
      var rate = 0;
      chipSets.forEach(function (set) {
        set.querySelectorAll('[data-nx-chip]').forEach(function (b) {
          var n = parseInt(b.dataset.nxChip, 10), on = n === chosen, r = parseInt(b.dataset.rate, 10) || 0;
          if (on) rate = r;
          b.classList.toggle('is-on', on);
          b.setAttribute('aria-checked', on ? 'true' : 'false');
          var p = b.querySelector('[data-nx-chip-price]');
          if (p && cents) {
            /* dollars large, cents small above them — the same as the Liquid prints */
            var each = Math.floor(cents * (100 - r) / 100), cc = each % 100;
            p.innerHTML = SYM + Math.floor(each / 100) + (cc ? '<sup>' + (cc < 10 ? '0' : '') + cc + '</sup>' : '');
          }
          var u = b.querySelector('[data-nx-chip-unit]');
          if (u && cents) u.textContent = money(cents);
          var sv = b.querySelector('[data-nx-chip-save]');
          if (sv && cents) sv.textContent = String(Math.floor(cents * n * r / 10000));
        });
      });
      if (chipQty) chipQty.value = chosen;
      hero.querySelectorAll('[data-nx-stock-copy]').forEach(function (el) {
        el.textContent = currentVariant && !currentVariant.available ? 'Sold out' : '';
      });
      if (mainAtc && !mainAtc.disabled) {
        mainAtc.innerHTML = eachOn ? atcLabel() : chosen > 1 && cents
          ? 'Add ' + chosen + ' to Cart · ' + moneyHTML(Math.floor(cents * chosen * (100 - rate) / 100))
          : 'Add to Cart';
      }
      if (eachOn) paintEach();
      /* The first-order band speaks for One only (owner, 2026-10-04): the code does not combine with the ladder, so at
         Two or Three it would offer what the cart will not give. It steps aside and comes back at One. */
      hero.querySelectorAll('.nxfo').forEach(function (fo) { fo.hidden = chosen > 1; });
    };
    chipSets.forEach(function (set) {
      set.addEventListener('click', function (e) {
        var b = e.target.closest('[data-nx-chip]');
        if (!b) return;
        chosen = parseInt(b.dataset.nxChip, 10) || 1;
        paintChips();
        chipEvent('nx_qty_pick_' + chosen);
      });
    });
    /* What the chips are for is measured, not guessed (owner, 2026-09-29): the quantity rides in the
       event's NAME, so tools/growth/ga4.mjs counts picks and adds per quantity without a custom
       dimension. gtag is looked up at send time — Google's tag lands after this deferred file. */
    var chipEvent = function (name) {
      try {
        var params = { product: (location.pathname.split('/products/')[1] || '').split('?')[0], look: chipSets[0].className.replace(/.*nxc--/, '') };
        if (typeof window.gtag === 'function') { window.gtag('event', name, params); return; }
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(Object.assign({ event: name }, params));
      } catch (e) { /* analytics never breaks the add */ }
    };
    if (form) form.addEventListener('submit', function () { chipEvent('nx_qty_add_' + chosen); }, true);
  }


  /* LOOK C — A COLOUR FOR EACH ONE (owner, 2026-09-30, the prototype "Bundle colours"). The last buyer took
     two diffusers in two colours, and through the Two chip that was only possible by fiddling in the cart.
     With Two or Three chosen, the colour's name in the line of choices becomes a door, "Both Stone Grey /
     Choose each colour ›", into a sheet with a row per unit. A dot on the page stays the fast path: every
     unit takes that colour. On a product with a second option the door stands from One up on a phone,
     "5000 mAh / Change capacity ›", and opens the shelf's own panel, so the words' pills leave the first
     screen. The add posts one line per variant; the ladder counts objects, so a mixed set gets the same rate.
     ⚠ The sheet is built on open and removed on close: nothing invisible stays over the page (the iPhone's
     status bar, 2026-09-30, docs/lessons/storefront.md). */
  var eachWrap = hero.querySelector('.nx-product-hero__options');
  var eachDoor = eachWrap && eachWrap.querySelector('[data-nx-each]');
  var eachRows = eachWrap ? Array.prototype.slice.call(eachWrap.querySelectorAll('[data-nx-option-pills]')) : [];
  var eachColour = -1;
  eachRows.forEach(function (w) { if (w.dataset.optionColour === 'true' && eachColour < 0) eachColour = parseInt(w.dataset.optionPosition, 10) - 1; });
  var eachOn = !!(eachDoor && variants.length > 1 && eachRows.length);
  var units = null; /* null: every unit is the page's own variant */
  var unitsLock = false;

  function eachFind(opts) {
    for (var i = 0; i < variants.length; i++) {
      if (variants[i].options.every(function (v, k) { return v === opts[k]; })) return variants[i];
    }
    return null;
  }
  function eachSet() {
    var out = [];
    for (var i = 0; i < chosen; i++) out.push((units ? units[i] : currentOptions).slice());
    return out;
  }
  function eachMixed() {
    if (!units || chosen < 2) return false;
    var s = eachSet();
    return s.some(function (o) { return o.join('|') !== s[0].join('|'); });
  }
  /* What the add posts and what the button says: one line per variant, the set's own prices. */
  function eachItems() {
    var byId = {}, order = [];
    eachSet().forEach(function (o) {
      var v = eachFind(o);
      if (!v) return;
      if (!byId[v.id]) { byId[v.id] = { id: Number(v.id), quantity: 0 }; order.push(v.id); }
      byId[v.id].quantity++;
    });
    return order.map(function (id) { return byId[id]; });
  }
  function eachCents() {
    return eachSet().reduce(function (sum, o) { var v = eachFind(o); return sum + (v ? v.cents : 0); }, 0);
  }
  function eachAvailable() {
    return eachSet().every(function (o) { var v = eachFind(o); return v && v.available; });
  }
  function eachHex(value) {
    var row = eachColour > -1 ? eachRows[eachColour] : null;
    var b = row && Array.prototype.slice.call(row.querySelectorAll('[data-nx-pill]')).filter(function (p) { return p.dataset.value === value; })[0];
    return b ? b.style.getPropertyValue('--nx-swatch') : '';
  }
  function eachValues(pos) {
    var row = eachRows[pos];
    return row ? Array.prototype.slice.call(row.querySelectorAll('[data-nx-pill]')).map(function (p) { return p.dataset.value; }) : [];
  }
  /* A colour's short name is its last word ("Champagne Gold" → "Gold") unless two of the product's colours share
     it ("Stone Grey", "Space Grey"), when the full names stand. The line clips what still does not fit. */
  function eachShort(list) {
    var all = eachColour > -1 ? eachValues(eachColour) : [];
    var last = function (v) { var w = String(v).trim().split(/\s+/); return w[w.length - 1]; };
    var clash = all.some(function (v, i) { return all.some(function (w, j) { return i !== j && last(v) === last(w); }); });
    var names = list.map(function (v) { return clash ? v : last(v); });
    return names.length === 2 ? names.join(' & ') : names.slice(0, -1).join(', ') + ' & ' + names[names.length - 1];
  }
  function eachName(pos) {
    var row = eachRows[pos];
    return row ? String(row.dataset.optionName || '') : '';
  }

  /* The page's own marks follow the set: a dot is ringed only while every unit wears it. */
  function eachMarks() {
    var s = eachSet();
    eachRows.forEach(function (row, pos) {
      var same = s.every(function (o) { return o[pos] === s[0][pos]; });
      row.querySelectorAll('[data-nx-pill]').forEach(function (p) {
        p.classList.toggle('nx-pill--active', same && p.dataset.value === s[0][pos]);
      });
    });
  }

  function paintEach() {
    if (!eachOn) return;
    /* One is the page's own variant: a mix made at Two must not mark a dot the add would not send. */
    if (chosen < 2) units = null;
    var multi = eachRows.length > 1;
    var mixed = eachMixed();
    var name = '', go = '', mode = '';
    /* ⚠ NOTHING MOVES (owner, 2026-10-01): the first door hid the colour's name and stood in its place, so the
       dots slid left to the words and the name jumped onto two lines. A one-option product now keeps its label
       exactly where One has it; "Choose each ›" appears beside the name on the same line, and a mix names itself
       "Two colours". A two-option product has its two-line door from One up, so it never changed shape. */
    if (!multi) {
      if (eachGo) {
        var seen = [];
        eachSet().forEach(function (o) { if (seen.indexOf(o[0]) < 0) seen.push(o[0]); });
        eachGo.hidden = chosen < 2;
        eachGo.querySelector('[data-t]').textContent = mixed ? 'Change' : 'Choose each';
        eachLabel.classList.toggle('is-door', chosen > 1);
        /* B (owner, 2026-10-02): at Two or Three the dots give their place to the door's pill (daytakt.css) */
        var eachRow = eachLabel.closest('.nx-product-hero__option');
        if (eachRow) eachRow.classList.toggle('is-each', chosen > 1);
        if (eachValue) eachValue.textContent = seen.length > 1 ? eachShort(seen) : currentOptions[0];
      }
      eachDoor.hidden = true;
      eachDoor.dataset.mode = '';
      eachMarks();
      return;
    }
    if (chosen > 1) {
      mode = 'unit';
      name = mixed ? 'Your mix' : (chosen === 2 ? 'Both alike' : 'All three alike');
      go = mixed ? 'Change' : 'Choose each';
    } else if (multi) {
      mode = 'opts';
      var words = currentOptions.filter(function (v, k) { return k !== eachColour; });
      var firstText = eachRows.map(function (r, k) { return k; }).filter(function (k) { return k !== eachColour; })[0];
      name = words.join(' · ');
      go = 'Change ' + eachName(firstText).toLowerCase();
    }
    eachDoor.hidden = !mode;
    eachDoor.dataset.mode = mode;
    eachWrap.classList.toggle('has-door', multi);
    eachWrap.classList.toggle('is-each', mode === 'unit');
    eachDoor.querySelector('[data-nx-each-name]').textContent = name;
    eachDoor.querySelector('[data-nx-each-go]').textContent = go;
    eachMarks();
  }

  /* ---- the sheet: built on open, removed on close ---- */
  var sheet = null;
  function sheetClose() {
    if (!sheet) return;
    var s = sheet;
    sheet = null;
    document.removeEventListener('keydown', sheetKey);
    s.classList.remove('is-in');
    setTimeout(function () { if (s.parentNode) s.parentNode.removeChild(s); }, 260);
    var back = eachGo && !eachGo.hidden ? eachGo : eachDoor;
    if (back && back.offsetParent) back.focus({ preventScroll: true });
  }
  function sheetKey(e) { if (e.key === 'Escape') sheetClose(); }
  function sheetOpen(kind, label, build) {
    sheetClose();
    var s = document.createElement('div');
    s.className = 'nx-sheet nx-sheet--' + kind;
    s.setAttribute('role', 'dialog');
    s.setAttribute('aria-modal', 'true');
    s.setAttribute('aria-label', label);
    s.innerHTML = '<button type="button" class="nx-sheet__scrim" aria-label="Close" tabindex="-1"></button><div class="nx-sheet__panel"></div>';
    s.querySelector('.nx-sheet__scrim').addEventListener('click', sheetClose);
    document.body.appendChild(s);
    sheet = s;
    build(s.querySelector('.nx-sheet__panel'));
    document.addEventListener('keydown', sheetKey);
    requestAnimationFrame(function () { requestAnimationFrame(function () { s.classList.add('is-in'); }); });
    var first = s.querySelector('.nx-sheet__x');
    if (first) first.focus({ preventScroll: true });
  }
  var closeSvg = '<svg viewBox="0 0 16 16" width="15" height="15" aria-hidden="true" focusable="false"><path d="M2.6 2.6l10.8 10.8M13.4 2.6L2.6 13.4" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>';
  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function moneyTag(c) { var cc = c % 100; return SYM + (c - cc) / 100 + (cc ? '<sup class="nx-cents">' + (cc < 10 ? '0' : '') + cc + '</sup>' : ''); }

  /* The per-unit sheet: a row per unit, its photo, its name, its words and its dots. Built once; a tap changes
     the marks, the name and the photo of its own row in place, so nothing in the sheet redraws or shifts. */
  function sheetUnits() {
    if (!units) units = [currentOptions.slice(), currentOptions.slice(), currentOptions.slice()];
    sheetOpen('units', 'Your set of ' + (chosen === 2 ? 'two' : 'three'), function (panel) {
      var html = '<div class="nx-sheet__head"><h2 class="nx-sheet__title">Your set of ' + (chosen === 2 ? 'two' : 'three') + '</h2>' +
        '<button type="button" class="nx-sheet__x" aria-label="Close">' + closeSvg + '</button></div><div class="nx-sheet__rows">';
      for (var i = 0; i < chosen; i++) {
        var o = units[i], v = eachFind(o);
        html += '<div class="nx-sheet__row" data-row="' + i + '"><img class="nx-sheet__img" alt="" src="' + esc(v && (v.thumb || v.featured_src) || '') + '" width="72" height="72">' +
          '<div class="nx-sheet__col"><span class="nx-sheet__name">' + esc(o.join(' · ')) + '</span>';
        eachRows.forEach(function (row, pos) {
          if (pos === eachColour) return;
          html += '<div class="nx-sheet__opts">';
          eachValues(pos).forEach(function (val) {
            html += '<button type="button" class="nx-sheet__opt nx-sheet__opt--text' + (o[pos] === val ? ' is-selected' : '') + '" data-u="' + i + '" data-pos="' + pos + '" data-val="' + esc(val) + '" aria-pressed="' + (o[pos] === val) + '">' + esc(val) + '</button>';
          });
          html += '</div>';
        });
        if (eachColour > -1) {
          html += '<div class="nx-sheet__opts">';
          eachValues(eachColour).forEach(function (val) {
            html += '<button type="button" class="nx-sheet__opt' + (o[eachColour] === val ? ' is-selected' : '') + '" data-u="' + i + '" data-pos="' + eachColour + '" data-val="' + esc(val) + '" aria-pressed="' + (o[eachColour] === val) + '" aria-label="' + (i + 1) + ': ' + esc(val) + '"><span class="nx-sheet__sw" style="background:' + esc(eachHex(val)) + '"></span></button>';
          });
          html += '</div>';
        }
        html += '</div></div>';
      }
      html += '</div><button type="button" class="nx-sheet__atc">' + atcLabel() + '</button>';
      panel.innerHTML = html;
      var atcBtn = panel.querySelector('.nx-sheet__atc');
      atcBtn.disabled = !eachAvailable();
      panel.querySelector('.nx-sheet__x').addEventListener('click', sheetClose);
      atcBtn.addEventListener('click', function () {
        if (!eachAvailable()) return;
        sheetClose();
        if (form) { if (form.requestSubmit) form.requestSubmit(); else form.dispatchEvent(new Event('submit', { cancelable: true })); }
      });
      panel.querySelectorAll('[data-u]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var u = parseInt(btn.dataset.u, 10), pos = parseInt(btn.dataset.pos, 10);
          if (units[u][pos] === btn.dataset.val) return;
          units[u][pos] = btn.dataset.val;
          var row = panel.querySelector('[data-row="' + u + '"]');
          row.querySelectorAll('[data-pos="' + pos + '"]').forEach(function (x) {
            var on = x.dataset.val === btn.dataset.val;
            x.classList.toggle('is-selected', on);
            x.setAttribute('aria-pressed', on ? 'true' : 'false');
          });
          row.querySelector('.nx-sheet__name').textContent = units[u].join(' · ');
          var nv = eachFind(units[u]), img = row.querySelector('.nx-sheet__img');
          var src = nv && (nv.thumb || nv.featured_src);
          if (src && img.getAttribute('src') !== src) img.setAttribute('src', src);
          eachSettle();
          atcBtn.innerHTML = atcLabel();
          atcBtn.disabled = !eachAvailable();
        });
      });
    });
  }
  /* A set that has become one variant again is simply the page's variant: the page follows it. */
  function eachSettle() {
    var s = eachSet();
    var same = s.every(function (o) { return o.join('|') === s[0].join('|'); });
    if (same && s[0].join('|') !== currentOptions.join('|')) {
      var v = eachFind(s[0]);
      if (v) { unitsLock = true; currentOptions = s[0].slice(); applyVariant(v); unitsLock = false; }
    }
    if (paintChips) paintChips();
    paintEach();
  }
  function atcLabel() {
    if (!currentVariant) return 'Add to Cart';
    if (!eachAvailable()) return 'Sold Out';
    if (chosen < 2) return 'Add to Cart';
    var rate = 0;
    var on = hero.querySelector('[data-nx-chip="' + chosen + '"]');
    if (on) rate = parseInt(on.dataset.rate, 10) || 0;
    return 'Add ' + chosen + ' to Cart · ' + moneyTag(Math.floor(eachCents() * (100 - rate) / 100));
  }

  /* The shelf's panel for One on a two-option product: its words and its dots move the page's own choice.
     Built once; a tap moves the page's choice and the panel's marks and price follow in place. */
  function sheetOpts() {
    sheetOpen('opts', 'Choose options', function (panel) {
      var html = '<button type="button" class="nx-sheet__x nx-sheet__x--corner" aria-label="Close">' + closeSvg + '</button>';
      eachRows.forEach(function (row, pos) {
        var colour = pos === eachColour;
        html += '<p class="nx-sheet__label">Select ' + esc(eachName(pos).toLowerCase()) + ':</p><div class="nx-sheet__opts' + (colour ? '' : ' nx-sheet__opts--text') + '">';
        eachValues(pos).forEach(function (val) {
          html += colour
            ? '<button type="button" class="nx-sheet__opt" data-pos="' + pos + '" data-val="' + esc(val) + '" aria-label="' + esc(val) + '"><span class="nx-sheet__sw" style="background:' + esc(eachHex(val)) + '"></span></button>'
            : '<button type="button" class="nx-sheet__opt nx-sheet__opt--text" data-pos="' + pos + '" data-val="' + esc(val) + '">' + esc(val) + '</button>';
        });
        html += '</div>';
      });
      html += '<button type="button" class="nx-sheet__add"></button>';
      panel.innerHTML = html;
      var add = panel.querySelector('.nx-sheet__add');
      function marks() {
        panel.querySelectorAll('[data-pos]').forEach(function (x) {
          var on = currentOptions[parseInt(x.dataset.pos, 10)] === x.dataset.val;
          x.classList.toggle('is-selected', on);
          x.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        var ok = currentVariant && currentVariant.available;
        add.disabled = !ok;
        add.innerHTML = ok ? moneyTag(currentVariant.cents) + ' <span class="nx-sheet__sep">·</span> Add to cart' : 'Sold out';
      }
      marks();
      panel.querySelector('.nx-sheet__x').addEventListener('click', sheetClose);
      add.addEventListener('click', function () {
        sheetClose();
        if (form) { if (form.requestSubmit) form.requestSubmit(); else form.dispatchEvent(new Event('submit', { cancelable: true })); }
      });
      panel.querySelectorAll('[data-pos]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var row = eachRows[parseInt(btn.dataset.pos, 10)];
          var pill = row && Array.prototype.slice.call(row.querySelectorAll('[data-nx-pill]')).filter(function (p) { return p.dataset.value === btn.dataset.val; })[0];
          if (pill) pill.click();
          marks();
        });
      });
    });
  }

  var eachLabel = null, eachValue = null, eachGo = null;
  if (eachOn && eachRows.length === 1) {
    var eachOpt = eachRows[0].closest('.nx-product-hero__option');
    eachLabel = eachOpt && eachOpt.querySelector('.nx-product-hero__option-label');
    if (eachLabel) {
      eachValue = eachLabel.querySelector('[data-nx-selected-option]');
      eachGo = document.createElement('button');
      eachGo.type = 'button';
      eachGo.className = 'nx-each-go';
      eachGo.hidden = true;
      eachGo.setAttribute('aria-haspopup', 'dialog');
      eachGo.innerHTML = '<span data-t></span><svg width="6" height="10" viewBox="0 0 6 10" fill="none" aria-hidden="true"><path d="M1 1l4 4-4 4" stroke="currentColor" stroke-width="1.6"/></svg>';
      eachLabel.appendChild(eachGo);
      /* the name is part of the door: a tap anywhere on the label opens the sheet while Two or Three is on */
      eachLabel.addEventListener('click', function () { if (chosen > 1) sheetUnits(); });
    }
  }
  if (eachOn) {
    eachDoor.addEventListener('click', function () {
      if (eachDoor.dataset.mode === 'unit') sheetUnits();
      else if (eachDoor.dataset.mode === 'opts') sheetOpts();
    });
    paintEach();
  }

  /* The refill band's plus: one set adds, more than one opens "Select set:" — the shelf's panel. */
  hero.querySelectorAll('[data-nx-refill-add]').forEach(function (b) {
    var box = b.closest('.nx-refill');
    var data = box && box.querySelector('[data-nx-refill-variants]');
    var sets = [];
    try { sets = data ? JSON.parse(data.textContent).filter(function (v) { return v.available; }) : []; } catch (e) { sets = []; }
    var price = parseInt(b.dataset.nxRefillPrice, 10) || 0;
    var optName = String(b.dataset.nxRefillOption || 'set').toLowerCase();
    function add(id) {
      b.disabled = true;
      Promise.resolve(cartAdd([{ id: Number(id), quantity: 1 }]))
        .catch(function () {})
        .then(function () { b.disabled = false; });
    }
    b.addEventListener('click', function () {
      if (b.disabled) return;
      if (sets.length < 2) { add(b.dataset.nxRefillAdd); return; }
      var pick = sets[0].id;
      sheetOpen('opts', 'Select ' + optName, function (panel) {
        var html = '<button type="button" class="nx-sheet__x nx-sheet__x--corner" aria-label="Close">' + closeSvg + '</button>' +
          '<p class="nx-sheet__label">Select ' + esc(optName) + ':</p><div class="nx-sheet__opts nx-sheet__opts--text">';
        sets.forEach(function (v) {
          html += '<button type="button" class="nx-sheet__opt nx-sheet__opt--text' + (v.id === pick ? ' is-selected' : '') + '" data-id="' + v.id + '" aria-pressed="' + (v.id === pick) + '">' + esc(v.title) + '</button>';
        });
        html += '</div><button type="button" class="nx-sheet__add">' + moneyTag(price) + ' <span class="nx-sheet__sep">·</span> Add to cart</button>';
        panel.innerHTML = html;
        panel.querySelector('.nx-sheet__x').addEventListener('click', sheetClose);
        panel.querySelectorAll('[data-id]').forEach(function (o) {
          o.addEventListener('click', function () {
            pick = Number(o.dataset.id);
            panel.querySelectorAll('[data-id]').forEach(function (x) {
              var on = Number(x.dataset.id) === pick;
              x.classList.toggle('is-selected', on);
              x.setAttribute('aria-pressed', on ? 'true' : 'false');
            });
          });
        });
        panel.querySelector('.nx-sheet__add').addEventListener('click', function () { sheetClose(); add(pick); });
      });
    });
  });

  var mainImage = hero.querySelector('[data-nx-main-media] .nx-product-hero__main-image');
  function showThumb(thumb) {
    hero.querySelectorAll('[data-nx-thumb]').forEach(function (t) {
      t.classList.remove('nx-product-hero__thumb--active');
    });
    thumb.classList.add('nx-product-hero__thumb--active');
    syncThumbPager(thumb);
    /* A video frame is not a src swap: the clip's sources come from Shopify's rendition list,
       which only Liquid has, so every video is already in the page, hidden. Showing one is
       therefore a matter of unhiding it and pausing whichever was playing. */
    var videos = hero.querySelectorAll('[data-nx-main-video]');
    var wanted = null;
    videos.forEach(function (v) {
      if (v.dataset.mediaId === thumb.dataset.mediaId) wanted = v;
      else { v.hidden = true; v.pause(); }
    });
    var mainBox = hero.querySelector('[data-nx-main-media]');
    if (mainImage) mainImage.hidden = !!wanted;
    if (mainBox) mainBox.classList.toggle('is-video', !!wanted);
    if (wanted) { wanted.hidden = false; return; }
    setMainImage(thumb.dataset.fullSrc);
  }
  hero.querySelectorAll('[data-nx-thumb]').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      /* The thumbnail already on show opens it large, as the main picture does (2026-09-30): Clarity
         recorded clicks on it that changed nothing, on a desktop, 29.09. */
      if (thumb.classList.contains('nx-product-hero__thumb--active')) {
        var shownMain = hero.querySelector('.nx-product-hero__main');
        if (shownMain) shownMain.click();
        return;
      }
      showThumb(thumb);
    });
  });

  /* THE STRIP SAYS HOW MANY AND HOW TO GO ON (owner, 2026-09-29). Thirteen thumbs with four and a
     half in view read as a row that simply stopped: nothing said there were more, and a mouse has
     no way to scroll a row whose scrollbar is hidden. Under it now sits the overlay's own pager,
     ‹ ▪▫▫ ›: a mark per frame, the one on show filled, and arrows that step the MAIN picture —
     the thing a reader actually wants to see bigger — while the strip slides to keep that thumb
     in view. The arrows stop at the ends rather than wrap, so the row has a visible last frame. */
  var thumbStrip = hero.querySelector('.nx-product-hero__thumbs');
  var thumbPager = hero.querySelector('[data-nx-thumb-pager]');
  function syncThumbPager(thumb) {
    if (!thumbPager || !thumbStrip) return;
    var all = Array.prototype.slice.call(hero.querySelectorAll('[data-nx-thumb]'));
    var at = all.indexOf(thumb);
    thumbPager.querySelectorAll('i').forEach(function (m, k) { m.className = k === at ? 'is-on' : ''; });
    var prev = thumbPager.querySelector('[data-nx-thumb-step="-1"]');
    var next = thumbPager.querySelector('[data-nx-thumb-step="1"]');
    if (prev) prev.disabled = at <= 0;
    if (next) next.disabled = at >= all.length - 1;
    /* scrollBy on the strip, never scrollIntoView: that one moves the page as well */
    var s = thumbStrip.getBoundingClientRect(), r = thumb.getBoundingClientRect();
    var by = r.left < s.left ? r.left - s.left : (r.right > s.right ? r.right - s.right : 0);
    if (by) thumbStrip.scrollBy({ left: by, behavior: 'smooth' });
  }
  /* THE STRIP IS DRAGGED WITH A MOUSE (owner, 2026-09-29): press on a thumb, move, and the row follows the
     hand as it does under a finger or a trackpad. A drag is not a click — once the pointer has travelled
     5px the release selects nothing. Images are not dragged out as files. */
  if (thumbStrip) {
    var drag = null, dragged = false;
    thumbStrip.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      drag = { x: e.clientX, left: thumbStrip.scrollLeft };
      dragged = false;
    });
    window.addEventListener('pointermove', function (e) {
      if (!drag) return;
      var dx = e.clientX - drag.x;
      if (!dragged && Math.abs(dx) > 5) { dragged = true; thumbStrip.classList.add('is-dragging'); }
      if (dragged) thumbStrip.scrollLeft = drag.left - dx;
    });
    window.addEventListener('pointerup', function () {
      if (!drag) return;
      drag = null;
      thumbStrip.classList.remove('is-dragging');
    });
    thumbStrip.addEventListener('click', function (e) {
      if (!dragged) return;
      dragged = false;
      e.stopPropagation();
      e.preventDefault();
    }, true);
    thumbStrip.addEventListener('dragstart', function (e) { e.preventDefault(); });
  }
  if (thumbPager) {
    thumbPager.addEventListener('click', function (e) {
      var b = e.target.closest('[data-nx-thumb-step]');
      if (!b || b.disabled) return;
      var all = Array.prototype.slice.call(hero.querySelectorAll('[data-nx-thumb]'));
      var at = all.indexOf(hero.querySelector('.nx-product-hero__thumb--active'));
      var go = all[at + parseInt(b.dataset.nxThumbStep, 10)];
      if (go) go.click();   /* the thumb's own click: same film handling, same depth count */
    });
  }

  /* The play mark is ours and it hides itself once the film runs — the browser's own button only
     appears under a pointer, and a still frame of a still object reads as a photograph until
     something says otherwise. Both galleries use the same two classes. */
  hero.querySelectorAll('[data-nx-main-video], .nx-product-hero__scroll-video').forEach(function (v) {
    var box = v.closest('.nx-product-hero__scroll-item') || v.closest('.nx-product-hero__main');
    if (!box) return;
    v.addEventListener('play', function () { box.classList.add('is-playing'); });
    v.addEventListener('pause', function () { box.classList.remove('is-playing'); });
    v.addEventListener('ended', function () { box.classList.remove('is-playing'); });
    /* The tap is the control, because the native bar is not ours to put in this gallery. Six
       seconds, muted, looping: play and pause is the whole vocabulary. */
    var toggle = function (e) {
      if (e) e.preventDefault();
      v.dataset.nxTouched = '1';
      if (v.paused) { var r = v.play(); if (r && r.catch) r.catch(function () {}); }
      else v.pause();
    };
    v.addEventListener('click', toggle);
    v.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') toggle(e);
    });

    /* The clip is fetched at `preload="none"`, so the page costs nothing until someone wants it —
       and the tap then waits for the first bytes: 169ms on a phone, 98 on a desktop (measured
       2026-09-24). Asking for the metadata the moment the frame is actually on screen spends a few
       kilobytes and hands the tap a decoder that is already open. Never before it is on screen. */
    /* ⚠ `load()` RESTARTS THE ELEMENT, so warming after a tap kills the very playback it was meant
       to speed up: on a desktop the video is hidden until its thumb is clicked, the observer then
       fired on the newly visible element and reset it — readyState 4, currentTime 0, paused.
       Measured 2026-09-24 before this guard. Once the reader has touched it, nothing warms. */
    var warm = function () {
      if (v.dataset.nxTouched || v.dataset.nxWarmed) return;
      if (v.readyState > 0 || !v.paused) return;
      v.dataset.nxWarmed = '1';
      v.preload = 'metadata';
      try { v.load(); } catch (e) { /* a browser that refuses is simply not warmed */ }
    };
    if (window.IntersectionObserver) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { if (en.isIntersecting) { warm(); io.disconnect(); } });
      }, { rootMargin: '0px', threshold: 0.25 });
      io.observe(v);
    } else {
      v.addEventListener('pointerenter', warm, { once: true });
    }
  });

  /* The phone's frame counter. It was a dot per frame until the gallery went from six frames to
     twelve (2026-09-20) and the dots became a grey smear that told the reader nothing about where
     they were. The number is written by the same scroll it used to light a dot from. */
  /* A number again since 2026-09-30 (owner): the marks were a row of their own under the photo.
     A round mark per photograph ON the photo since 2026-10-01 (owner, from frames: "1 / 14" told how many there
     were, and five squares in a plate did not suit). The frame's own mark is lit as the strip scrolls. */
  var dots = hero.querySelector('[data-nx-dots]');
  var scroller = dots && hero.querySelector('.nx-product-hero__scroller');
  if (scroller) {
    var lit = 0;
    scroller.addEventListener(
      'scroll',
      function () {
        var index = Math.round(scroller.scrollLeft / scroller.clientWidth);
        if (index === lit || !dots.children[index]) return;
        dots.children[lit].classList.remove('is-on');
        dots.children[index].classList.add('is-on');
        lit = index;
      },
      { passive: true }
    );
  }

  /* THE STRIP LOADS AHEAD OF THE THUMB (owner, 2026-10-02: a fast swipe met alt text, then the photo cut in). Safari
     asks for a lazy frame only when it is almost on screen, so every swipe landed on a picture still on its way:
     WebKit at a phone's latency showed 18 frames without a photo, the longest gap 992ms. The frame on show, the one
     behind it and three ahead go eager; each is decoded before it is shown and comes up over its blurred copy
     (.is-warm / .is-in in the section's stylesheet). A held frame (nx-hold-img) keeps waiting for the release: eager
     only says what happens once it has a src. The viewer warms the same pictures (warmNeighbours) — its reel reads them. */
  var strip0 = hero.querySelector('.nx-product-hero__scroller');
  if (strip0) {
    var stripItems = Array.prototype.slice.call(strip0.children);
    var shown = function (im) { im.classList.add('is-in'); };
    stripItems.forEach(function (it, i) {
      var im = it.querySelector('img');
      if (!im || i === 0) return;
      if (im.complete && im.naturalWidth) { shown(im); return; }
      im.addEventListener('load', function () {
        if (im.decode) im.decode().then(function () { shown(im); }, function () { shown(im); });
        else shown(im);
      });
      im.addEventListener('error', function () { shown(im); });
    });
    strip0.classList.add('is-warm');
    var warmAt = -1;
    var nxWarm = function (i) {
      for (var k = i - 1; k <= i + 3; k++) {
        var im = stripItems[k] && stripItems[k].querySelector('img');
        if (im && im.loading === 'lazy') im.loading = 'eager';
      }
    };
    var warmStrip = function () {
      /* a desktop keeps the strip in the page but hidden, and an eager picture in it would still download */
      if (!strip0.clientWidth) return;
      var i = Math.round(strip0.scrollLeft / strip0.clientWidth);
      if (i === warmAt) return;
      warmAt = i;
      nxWarm(i);
    };
    warmStrip();
    strip0.addEventListener('scroll', warmStrip, { passive: true });
  }


  /* The Product Story's own ADD TO CART opens the drawer, like every other
     add in the store. It used to post the form and land the reader on a
     full /cart page — the one place in the store that broke the pattern,
     and the owner asked why. `window.nxCart` is set up by nx-quick-add.js;
     it is read at CLICK time, not at bind time, because both files are
     deferred and their order is a section-tag detail. If it is missing the
     form posts as before, which is the correct thing to fall back to. */
  if (form) {
    form.addEventListener('submit', function (e) {
      var mixedSet = eachOn && eachMixed();
      /* Without the drawer the form would post the page's one variant and lose the set: send the set. */
      if (!window.nxCart) { if (mixedSet) { e.preventDefault(); cartAdd(eachItems()); } return; }
      var id = variantIdInput && variantIdInput.value;
      if (!id) return;
      e.preventDefault();

      var qtyInput = hero.querySelector('[data-nx-qty-input]');
      var qty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
      var titleEl = hero.querySelector('.nx-product-hero__title');
      var name = titleEl ? titleEl.textContent.trim() : 'Item';

      atcButtons.forEach(function (b) {
        b.disabled = true;
      });

      window.nxCart
        .add(mixedSet ? eachItems() : [{ id: Number(id), quantity: qty }], name + ' · ' + qty + ' added to your cart')
        .catch(function () {
          form.submit(); // the page is a worse answer, but it is an answer
        })
        .then(function () {
          atcButtons.forEach(function (b) {
            b.disabled = false;
          });
        });
    });
  }

  if (form && stickyBar) {
    // The bar stands in for the real Add to Cart, so it may only appear
    // once the real one has scrolled ABOVE the viewport.
    //
    // The previous rule showed it whenever the form was not intersecting,
    // and at the top of a phone page the form is not intersecting either —
    // it is still below the fold. So the bar was there from the first
    // paint, covering the product's own title and quoting a price the
    // reader had not been shown yet. Watching the button and checking
    // which side it left on is the whole fix.
    var mainAtc = form.querySelector('.nx-buy-buttons__atc') || form;

    // Two independent conditions, one bar. `past` is the rule above;
    // `rivals` is how many bands with their own Add to Cart are on screen.
    var past = false;
    var rivals = 0;

    var apply = function () {
      if (past && rivals === 0) stickyBar.setAttribute('data-nx-visible', 'true');
      else stickyBar.removeAttribute('data-nx-visible');
    };

    /* ⚠ THE OBSERVER ALONE IS NOT ENOUGH, and the owner saw why: closing the zoom overlay left the
       bar up while the real Add to Cart stood on the first screen — two identical buttons, one over
       the other (2026-09-21). Locking the page's scroll for the overlay and restoring it afterwards
       moves nothing as far as an observer is concerned, so no change is reported and `past` keeps the
       value it had deep down the page. The button's own box is the truth; this reads it on scroll and
       whenever something says the page has moved under it. */
    var recheck = function () {
      var box = mainAtc.getBoundingClientRect();
      past = box.bottom <= 0;
      apply();
    };
    var pending = false;
    addEventListener('scroll', function () {
      if (pending) return;
      pending = true;
      requestAnimationFrame(function () { pending = false; recheck(); });
    }, { passive: true });
    addEventListener('resize', recheck, { passive: true });
    document.addEventListener('nx:recheck-sticky', recheck);

    // ⚠ `past` is which SIDE of the screen the button is on, not the moment it crosses the edge.
    // An observer reports only a change, and a jump from deep in the page back to the top — iOS's
    // tap on the clock, a fast flick, a script's scrollTo — carries the button from above the
    // screen to below it without its ever being on it: nothing changed, nothing was reported, and
    // the bar stayed up over the colour pickers on the first screen (2026-09-16, found through
    // probe.mjs, which scrolls a page through and jumps back). With the root stretched endlessly
    // downward, "anywhere below the top of the screen" is one state and "above it" the other, so
    // every such jump is a change and is reported.
    new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          past = !entry.isIntersecting;
        });
        apply();
      },
      { threshold: 0, rootMargin: '0px 0px 100000px 0px' }
    ).observe(mainAtc);

    // A band that sells something else must not be read through a floating
    // button for this product. On a phone the bundle's "Add 4 objects" sat
    // directly under the sticky bar — two Add to Carts, the wrong one on
    // top. The bar stands down while such a band is on screen and comes
    // back once it has gone by.
    // ⚠ `.nxsys` is in this list because the Product Story's systems band
    // is now the homepage's section, not `nx-product-system` — and a band
    // that sells something else must not be read through a floating button
    // for this product. Leaving it out would put "Add the system" directly
    // under the sticky bar again: two Add to Carts, the wrong one on top.
    // Any band can claim the same right with data-nx-sticky-rival: the Meta scents band's "Add a refill set" sat
    // under the floating Add to Cart, two clay pills one over the other (owner, 2026-10-15).
    var sellers = document.querySelectorAll('.nxsys, [data-nx-sticky-rival]');
    if (sellers.length) {
      var rivalObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            var was = entry.target.dataset.nxOnScreen === '1';
            if (was === entry.isIntersecting) return;
            entry.target.dataset.nxOnScreen = entry.isIntersecting ? '1' : '0';
            rivals += entry.isIntersecting ? 1 : -1;
          });
          if (rivals < 0) rivals = 0;
          apply();
        },
        { threshold: 0 }
      );
      sellers.forEach(function (s) {
        rivalObserver.observe(s);
      });
    }
  }
});

document.querySelectorAll('[id^="NxDesignedFor-"]').forEach(function (sec) {
  var track = sec.querySelector('[data-nx-df-track]');
  if (!track) return;
  var dots = sec.querySelectorAll('[data-nx-df-dots] .nx-designed-for__dot');
  var hint = sec.querySelector('[data-nx-df-hint]');
  var cards = track.querySelectorAll('.nx-designed-for__card');
  if (cards.length < 2) return;

  track.addEventListener(
    'scroll',
    function () {
      var stride = track.scrollWidth / cards.length;
      var i = stride ? Math.round(track.scrollLeft / stride) : 0;
      if (i < 0) i = 0;
      if (i > cards.length - 1) i = cards.length - 1;
      dots.forEach(function (dot, idx) {
        dot.classList.toggle('nx-designed-for__dot--active', idx === i);
      });
      if (hint && track.scrollLeft > 8) hint.classList.add('nx-designed-for__hint--hidden');
    },
    { passive: true }
  );
});

document.querySelectorAll('[data-nx-reviews]').forEach(function (sec) {
  var track = sec.querySelector('[data-nx-reviews-track]');
  if (!track) return;
  var cards = Array.prototype.slice.call(track.querySelectorAll('.nx-reviews__card'));
  if (cards.length === 0) return;
  var nav = sec.querySelector('[data-nx-reviews-nav]');
  var prevBtn = sec.querySelector('[data-nx-reviews-prev]');
  var nextBtn = sec.querySelector('[data-nx-reviews-next]');
  var countEl = sec.querySelector('[data-nx-reviews-count]');
  var pageSize = parseInt(sec.getAttribute('data-nx-reviews-page-size'), 10) || 6;
  var total = cards.length;
  var pages = Math.ceil(total / pageSize);
  var page = 0;
  // A phone reads the whole list, folded after three cards (CUT AND OPEN, below); pages are a desktop's.
  var phone = window.matchMedia('(max-width: 749px)');

  function renderPage() {
    var whole = phone.matches;
    var start = page * pageSize;
    var end = start + pageSize;
    cards.forEach(function (c, i) {
      c.style.display = whole || (i >= start && i < end) ? '' : 'none';
    });
    if (nav) {
      nav.hidden = whole || pages <= 1;
      if (prevBtn) prevBtn.disabled = page === 0;
      if (nextBtn) nextBtn.disabled = page >= pages - 1;
      if (countEl) countEl.textContent = page + 1 + ' / ' + pages;
    }
  }

  if (prevBtn) prevBtn.addEventListener('click', function () { if (page > 0) { page--; renderPage(); } });
  if (nextBtn) nextBtn.addEventListener('click', function () { if (page < pages - 1) { page++; renderPage(); } });
  if (phone.addEventListener) phone.addEventListener('change', renderPage);

  renderPage();
});

/* ==================================================================
   GALLERY ZOOM (2026-08-01)

   The whole argument for several of these products is printed on them —
   port labels, a display's digits, the knurling on a cap — and at gallery
   size none of it can be read. A shopper who cannot read the ports cannot
   decide, so the picture has to open.

   One overlay for the page, built once and reused. On a desktop the image
   fills the screen's height; below 990px the whole picture fits the screen
   and a pinch enlarges it (2026-09-14 — it opened twice the screen's width).
   Escape, the cross, a click on the ground, a swipe down and the browser's
   Back close. A tap on the picture enlarges it and does not close it
   (2026-09-21 and 10-08, below). ⚠ Clarity hides this overlay in its replays,
   so a tap that enlarged the picture shows there as a dead click: a "Close"
   at the bottom was built on that reading on 2026-10-21 and taken off the
   same day (owner).

   ⚠ Four things a phone did wrong until 2026-09-13, reproduced on the-perch
   after a Clarity recording of a visitor tapping the picture and "Reviews"
   again and again:
   - the overlay opened on the 2048px file (453 KB), so on slow 4G it showed
     the page itself under the veil for seconds, "17 Reviews" included, and
     a tap on that link closed the overlay instead of following it. It now
     opens on the picture the page has already downloaded and swaps in the
     big one when it arrives;
   - a tap on the picture did nothing, though the cursor says zoom-out;
   - dragging to see the right half of a wide picture flipped to the next
     one. A swipe pages only when the frame is already at that edge;
   - Back left the product page. The overlay now takes a history entry.
   ================================================================== */
(function () {
  var overlay = null;
  var img = null;
  var frame = null;
  var lastFocus = null;
  var prevBtn = null;
  var nextBtn = null;
  var countEl = null;
  var captionEl = null;
  var sideBtns = [];
  var panned = false;
  var list = [];
  var at = 0;
  var showing = 0;
  var scrollWas = null;
  var inHistory = false;
  var openedBy = 'pointer';   /* 'key' when Enter or Space opened the viewer: then the picture keeps its ring on return */

  function build() {
    overlay = document.createElement('div');
    overlay.className = 'nx-zoom';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.setAttribute('aria-label', 'Product image');
    overlay.hidden = true;
    var ARROW =
      '<svg viewBox="0 0 10 16" fill="none" aria-hidden="true">' +
      '<path d="M8 1L2 8l6 7" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    overlay.innerHTML =
      '<button class="nx-zoom__x" type="button" aria-label="Close">' +
      '<svg viewBox="0 0 16 16" fill="none" aria-hidden="true"><path d="M1 1l14 14M15 1L1 15" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>' +
      '</button>' +
      '<button class="nx-zoom__step nx-zoom__step--prev" type="button" aria-label="Previous image">' + ARROW + '</button>' +
      '<button class="nx-zoom__step nx-zoom__step--next" type="button" aria-label="Next image">' + ARROW + '</button>' +
      '<div class="nx-zoom__caption" aria-hidden="true"></div>' +
      '<div class="nx-zoom__frame"><img class="nx-zoom__img" alt=""></div>' +
      '<div class="nx-zoom__pager"><span class="nx-zoom__marks" aria-hidden="true"></span></div>';
    document.body.appendChild(overlay);
    img = overlay.querySelector('.nx-zoom__img');
    /* ⚠ NO EMPTY FRAME BETWEEN TWO FILES (owner, 2026-10-01: each photo "blinks once more" as it arrives). Safari decodes
       a big picture after it has swapped the src and paints the gap; sync makes the swap wait for the decode. */
    img.decoding = 'sync';
    frame = overlay.querySelector('.nx-zoom__frame');
    prevBtn = overlay.querySelector('.nx-zoom__step--prev');
    nextBtn = overlay.querySelector('.nx-zoom__step--next');
    countEl = overlay.querySelector('.nx-zoom__marks');
    captionEl = overlay.querySelector('.nx-zoom__caption');
    // The picture arrives after the caption does, and its drawn height is what the caption is
    // anchored to — so place it again once the file is actually decoded, and on a turn of the phone.
    img.addEventListener('load', placeCaption);
    window.addEventListener('resize', placeCaption);
    /* ⚠ Marks, not a number (owner, 2026-09-21). "11 / 14" told the reader how much was left rather
       than where they were, and the pager reads as a control only when the arrows stand beside the
       marks: ‹ ▫▫▪▫▫ ›. The arrows move into that row on every width. */
    var pager = overlay.querySelector('.nx-zoom__pager');
    pager.insertBefore(prevBtn, countEl);
    pager.appendChild(nextBtn);

    prevBtn.addEventListener('click', function (e) { e.stopPropagation(); step(-1); });
    nextBtn.addEventListener('click', function (e) { e.stopPropagation(); step(1); });

    /* ⚠ ON A DESKTOP THE DARK EITHER SIDE OF THE PICTURE PAGES (owner, 2026-09-29). The only way
       on was a pair of 44px chevrons in the bottom corners, paper on nothing, and on a pale frame
       they vanished. Now a click anywhere left of the picture goes back and anywhere right goes on,
       and each side carries its arrow at mid-height in a dark square that reads on any frame. The
       ground above and below the picture still closes. Hidden below 990px, where a swipe pages. */
    sideBtns = ['prev', 'next'].map(function (k) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'nx-zoom__side nx-zoom__side--' + k;
      b.setAttribute('aria-label', k === 'prev' ? 'Previous image' : 'Next image');
      b.innerHTML = '<span>' + ARROW + '</span>';
      b.addEventListener('click', function (e) { e.stopPropagation(); step(k === 'prev' ? -1 : 1); });
      overlay.appendChild(b);
      return b;
    });
    img.addEventListener('load', placeSides);

    /* ⚠ ENLARGED, THE WHEEL MOVES THE PICTURE BOTH WAYS (owner, 2026-10-05: "прокручивать можно только вверх-вниз, а
       влево-вправо нельзя"). The wheel used to enlarge and shrink it around the pointer, so a scroll up or down read as
       moving and a touchpad's sideways scroll did nothing. Now a scroll pans it like a page, sideways too (shift + the
       wheel on a mouse); the size is the click's, and a touchpad pinch or ctrl + the wheel still enlarge around the
       pointer, up to MAX_ZOOM and back down to the whole frame. On the whole frame a plain scroll does nothing. The
       transform and its limits are the pinch's own (placeZoom): the picture's edge never comes inside the screen's. */
    overlay.addEventListener('wheel', function (e) {
      if (overlay.hidden || fitted() || frame.classList.contains('is-video')) return;
      e.preventDefault();
      img.classList.remove('is-easing');
      if (!e.ctrlKey) {
        if (zoom.s <= 1) return;
        var unit = e.deltaMode === 1 ? 16 : e.deltaMode === 2 ? overlay.clientHeight : 1;
        var dx = e.deltaX * unit, dy = e.deltaY * unit;
        if (e.shiftKey && !dx) { dx = dy; dy = 0; }
        zoom.x -= dx;
        zoom.y -= dy;
        placeZoom();
        return;
      }
      var box = frame.getBoundingClientRect();
      var s = Math.min(MAX_ZOOM, Math.max(1, zoom.s * Math.exp(-e.deltaY * 0.0015)));
      if (s < 1.03) { resetZoom(); return; }
      zoom.x = e.clientX - box.left - (e.clientX - box.left - zoom.x) * s / zoom.s;
      zoom.y = e.clientY - box.top - (e.clientY - box.top - zoom.y) * s / zoom.s;
      zoom.s = s;
      overlay.classList.add('is-zoomed');
      placeZoom();
    }, { passive: false });
    var mpan = null;   /* the mouse's; `pan` above is the finger's */
    img.addEventListener('mousedown', function (e) {
      if (fitted() || zoom.s <= 1 || e.button !== 0) return;
      e.preventDefault();
      img.classList.remove('is-easing');
      mpan = { x: e.clientX, y: e.clientY, zx: zoom.x, zy: zoom.y };
      panned = false;
      overlay.classList.add('is-panning');
    });
    addEventListener('mousemove', function (e) {
      if (!mpan) return;
      var dx = e.clientX - mpan.x, dy = e.clientY - mpan.y;
      if (Math.abs(dx) + Math.abs(dy) > 4) panned = true;
      zoom.x = mpan.zx + dx;
      zoom.y = mpan.zy + dy;
      placeZoom();
    });
    addEventListener('mouseup', function () {
      if (!mpan) return;
      mpan = null;
      overlay.classList.remove('is-panning');
    });
    window.addEventListener('resize', placeSides);

    /* ⚠ THE PICTURE DOES NOT CLOSE THE OVERLAY (owner, 2026-09-21). It used to: "anything but the
       arrows closes". On a phone a swipe shorter than 45px ends as a click, so every attempt to page
       through the gallery shut it instead — the overlay read as "nothing works here but leaving".
       The ground closes, the cross closes, Escape and Back close, and a swipe down closes. */
    overlay.addEventListener('click', function (e) {
      if (gestured) { gestured = false; return; }
      if (e.target.closest('.nx-zoom__step, .nx-zoom__side')) return;
      /* ⚠ ON A DESKTOP A CLICK ON THE PICTURE ENLARGES IT, AS AT NATIVE UNION (owner, 2026-10-02): the cursor is
         zoom-in, a click makes it three times the size around the point under the pointer — the phone's double tap,
         toggleZoom — the cursor turns to a hand and the picture is dragged; one more click brings back the whole
         frame. Until then a click on the picture closed the viewer (2026-09-29); now the ground, the cross and
         Escape close it. The end of a drag is not a click. The phone keeps the rule above: there a short swipe
         ends as a click. */
      if (!fitted() && e.target === img) {
        if (panned) { panned = false; return; }
        toggleZoom(e.clientX, e.clientY);
        return;
      }
      if (e.target.closest('.nx-zoom__x') || e.target === overlay || e.target === frame) close();
    });
    addEventListener('keydown', function (e) {
      if (overlay.hidden) return;
      if (e.key === 'Escape') close();
      else if (e.key === 'ArrowLeft') { e.preventDefault(); step(-1); }
      else if (e.key === 'ArrowRight') { e.preventDefault(); step(1); }
    });
    // Back closes the overlay rather than leaving the product page.
    addEventListener('popstate', function () {
      inHistory = false;
      if (!overlay.hidden) close(true);
    });

    /* On a phone there are no arrows worth pressing, so the gallery is
       swiped: horizontal only, past 45px, and only while the picture is at
       its fitted size. Two fingers enlarge it, one finger then pans it, and
       neither pages (owner, 2026-09-14). Below 990px the overlay refuses the
       browser's own pinch (touch-action in daytakt.css, Safari's gesture
       event here) and runs its own. On a desktop the picture can be wider
       than the screen, so there a swipe pages only from the frame's edge. */
    var x0 = null, y0 = null, left0 = 0, maxLeft = 0;
    var pinch = null, pan = null, gestured = false;
    /* A tap on the picture enlarges it around the tapped point, and a tap on the enlarged picture brings it
       back to the whole frame (owner, 2026-10-08; until then it took a double tap, 2026-10-01). A tap is a
       touch that did not move and did not linger; a second one close in time and place is the double tap,
       and is swallowed (touchend). */
    var tap0 = null, lastTap = null;
    var spread = function (t) { return Math.hypot(t[0].clientX - t[1].clientX, t[0].clientY - t[1].clientY) || 1; };
    overlay.addEventListener('touchstart', function (e) {
      tap0 = e.touches.length === 1 ? { x: e.touches[0].clientX, y: e.touches[0].clientY, t: Date.now(), on: e.target === img } : null;
      if (e.touches.length >= 2) {
        lastTap = null;
        x0 = null; pan = null;
        if (!fitted()) return;
        gestured = true;
        upgradeFull();
        var t = e.touches;
        pinch = { d: spread(t), mx: (t[0].clientX + t[1].clientX) / 2, my: (t[0].clientY + t[1].clientY) / 2, s: zoom.s, x: zoom.x, y: zoom.y };
        return;
      }
      if (!pinch) gestured = false;
      x0 = e.touches[0].clientX;
      y0 = e.touches[0].clientY;
      left0 = frame.scrollLeft;
      maxLeft = frame.scrollWidth - frame.clientWidth;
      pan = zoom.s > 1 ? { x: zoom.x, y: zoom.y } : null;
    }, { passive: true });
    overlay.addEventListener('touchmove', function (e) {
      if (pinch && e.touches.length >= 2) {
        e.preventDefault();
        var t = e.touches, box = frame.getBoundingClientRect();
        var s = Math.min(MAX_ZOOM, Math.max(1, pinch.s * spread(t) / pinch.d));
        // The point of the picture that was under the fingers stays under them.
        zoom.x = (t[0].clientX + t[1].clientX) / 2 - box.left - (pinch.mx - box.left - pinch.x) * s / pinch.s;
        zoom.y = (t[0].clientY + t[1].clientY) / 2 - box.top - (pinch.my - box.top - pinch.y) * s / pinch.s;
        zoom.s = s;
        placeZoom();
      } else if (!pan && !pinch && e.touches.length === 1 && x0 !== null && fitted() && zoom.s === 1) {
        var sx = e.touches[0].clientX - x0, sy = e.touches[0].clientY - y0;
        if (Math.abs(sx) > 10 && Math.abs(sx) > Math.abs(sy)) { gestured = true; dragTo(sx); }
      } else if (pan && e.touches.length === 1) {
        e.preventDefault();
        var dx = e.touches[0].clientX - x0, dy = e.touches[0].clientY - y0;
        if (Math.abs(dx) > 8 || Math.abs(dy) > 8) gestured = true;
        zoom.x = pan.x + dx;
        zoom.y = pan.y + dy;
        placeZoom();
      }
    }, { passive: false });
    overlay.addEventListener('touchend', function (e) {
      var c = e.changedTouches[0];
      if (!pinch && fitted() && tap0 && tap0.on && c && !e.touches.length && !frame.classList.contains('is-video')
          && Math.abs(c.clientX - tap0.x) < 10 && Math.abs(c.clientY - tap0.y) < 10 && Date.now() - tap0.t < 300) {
        /* ⚠ ONE TAP ENLARGES (owner, 2026-10-08, variant B of two frames). The viewer answered only a double tap, and
           Clarity saw a reader on the sleep mask tap the picture a dozen times in three seconds and leave. A tap now does
           what a click does on a desktop: three times around the point, and a tap on the enlarged picture brings the
           frame back. A swipe is not a tap — past 10px or 300ms it pages, as before. The second tap of a double tap is
           swallowed: the first one already answered, and toggling back would read as nothing happening. */
        if (lastTap && Date.now() - lastTap.t < 350 && Math.hypot(c.clientX - lastTap.x, c.clientY - lastTap.y) < 40) {
          lastTap = null; tap0 = null; pan = null; x0 = null;
          gestured = true;   /* the click this tap makes is not a tap on the ground */
          return;
        }
        lastTap = { x: c.clientX, y: c.clientY, t: Date.now() };
        tap0 = null; pan = null; x0 = null;
        gestured = true;
        toggleZoom(c.clientX, c.clientY);
        return;
      } else if (!pinch) {
        lastTap = null;
      }
      if (pinch) {
        if (e.touches.length >= 2) return;
        pinch = null;
        if (zoom.s < 1.05) resetZoom();
        // The finger still down carries on as a pan, never as a swipe.
        if (e.touches.length === 1 && zoom.s > 1) {
          x0 = e.touches[0].clientX;
          y0 = e.touches[0].clientY;
          pan = { x: zoom.x, y: zoom.y };
        }
        return;
      }
      if (pan) { pan = null; x0 = null; return; }
      if (x0 === null || !e.changedTouches.length) return;
      var dx = e.changedTouches[0].clientX - x0;
      var dy = e.changedTouches[0].clientY - y0;
      x0 = null;
      // down and away: the gesture every photo viewer answers to
      if (fitted() && dy > 90 && Math.abs(dy) > Math.abs(dx) * 1.5) { dragEnd(0, 0); close(); return; }
      if (Math.abs(dx) <= 45 || Math.abs(dx) <= Math.abs(dy) * 1.5) { dragEnd(0, 0); return; }
      var forward = dx < 0;
      var atEdge = maxLeft <= 2 || (forward ? left0 >= maxLeft - 2 : left0 <= 2);
      if (atEdge) dragEnd(dx, forward ? 1 : -1); else dragEnd(0, 0);
    }, { passive: true });
    overlay.addEventListener('touchcancel', function () { pinch = null; pan = null; x0 = null; });
    overlay.addEventListener('gesturestart', function (e) { if (fitted()) e.preventDefault(); });
    addEventListener('resize', function () {
      if (overlay.hidden) return;
      if (fitted()) placeZoom(); else resetZoom();
    });
  }

  /* The enlarged picture stays on the screen: while it is wider (or taller)
     than the screen its edge never comes inside the screen's edge, and while
     it is narrower it stays centred. The picture sits in its box by
     object-fit: contain, so its own size is worked out from its pixels. */
  var MAX_ZOOM = 4;
  var zoom = { s: 1, x: 0, y: 0 };
  function fitted() { return window.matchMedia('(max-width: 989px)').matches; }
  function keep(t, boxEdge, inset, size, screen) {
    var span = size * zoom.s, edge = boxEdge + inset * zoom.s;
    if (span <= screen) return (screen - span) / 2 - edge;
    return Math.min(-edge, Math.max(screen - span - edge, t));
  }
  function placeZoom() {
    var box = frame.getBoundingClientRect();
    var nw = img.naturalWidth || box.width, nh = img.naturalHeight || box.height;
    var k = Math.min(box.width / nw, box.height / nh);
    zoom.x = keep(zoom.x, box.left, (box.width - nw * k) / 2, nw * k, overlay.clientWidth);
    zoom.y = keep(zoom.y, box.top, (box.height - nh * k) / 2, nh * k, overlay.clientHeight);
    img.style.transform = zoom.s > 1 ? 'translate(' + zoom.x + 'px,' + zoom.y + 'px) scale(' + zoom.s + ')' : '';
  }
  function resetZoom() {
    zoom.s = 1; zoom.x = 0; zoom.y = 0;
    if (img) img.style.transform = '';
    if (overlay) overlay.classList.remove('is-zoomed');
  }
  /* the 2048px file, decoded off-screen first, for the picture on show (see show()) */
  function upgradeFull() {
    var want = img && img.dataset.nxFull;
    if (!want) return;
    var mine = showing;
    var full = new Image();
    var go = function () { if (mine === showing && overlay && !overlay.hidden && img.dataset.nxFull === want) { img.src = want; img.dataset.nxFull = ''; } };
    full.onload = function () { if (full.decode) full.decode().then(go, go); else go(); };
    full.src = want;
  }
  /* The double tap: three times the size with the tapped point staying under the finger, or back to the whole
     frame (owner, 2026-10-01: at twice, a square photo is exactly the phone's height, so a finger could only move it
     sideways and the corners felt out of reach). It eases (.is-easing in daytakt.css); a pinch and a pan follow the fingers and never do. */
  var easeTimer = null, TAP_ZOOM = 3;
  function toggleZoom(px, py) {
    if (!img || !frame) return;
    img.classList.add('is-easing');
    clearTimeout(easeTimer);
    easeTimer = setTimeout(function () { img.classList.remove('is-easing'); }, 300);
    if (zoom.s > 1) { resetZoom(); return; }
    upgradeFull();
    var box = frame.getBoundingClientRect();
    zoom.x = (px - box.left) * (1 - TAP_ZOOM);
    zoom.y = (py - box.top) * (1 - TAP_ZOOM);
    zoom.s = TAP_ZOOM;
    overlay.classList.add('is-zoomed');
    placeZoom();
  }

  /* Paging inside the overlay. The owner opened a picture to read the
     ports on it and then had to close, pick the next thumb and open
     again — which is not a gallery, it is a lightbox that forgot it was
     one. The list is handed in by whatever opened the overlay. */
  /* ⚠ A REEL, not a swap with a fade. The first attempt slid the frame out, changed the src and slid
     it back in: between the two the frame held nothing, so the screen went black, and a swipe that
     shows nothing coming reads as a jump rather than a gallery (owner, 2026-09-21).
     The neighbours stand beside the current picture, at plus and minus a screen, already carrying
     the small file the page has downloaded — so there is something to see the moment the finger
     moves, and nothing to wait for. The frame carries the slide; the image keeps the pinch. */
  var sliding = false;
  var ghosts = null;

  /* ⚠ ON A PHONE THE REEL SHOWS THE STRIP'S 800px COPY, NEVER WAITS FOR 2048 (owner, 2026-10-02: "одна картинка резко
     сменяется другой"). A neighbour the strip had not loaded when the viewer opened had no preview, so its ghost asked
     for the 2048px file and slid in empty; the photo cut in when it landed — 15.6% of the frames of six swipes, the
     longest gap 1.2s (Chromium, a phone's 4G). The copy is read when it is needed, and failing it the same 800px
     address the strip would ask for, so the two share one download. The big file still waits for a zoom. */
  function phoneSrc(item) {
    var s = item.slide;
    if (s && s.complete && s.naturalWidth > 1) return s.currentSrc;
    return item.preview || String(item.src).replace(/([?&])width=\d+/, '$1width=800');
  }
  function warmNeighbours() {
    if (list.length < 2) return;
    [1, -1, 2].forEach(function (d) {
      var it = list[(at + d + list.length) % list.length];
      if (it && it.slide && it.slide.loading === 'lazy') it.slide.loading = 'eager';
    });
  }

  function ghostFor(index, dx) {
    var item = list[(index + list.length) % list.length];
    var g = img.cloneNode(false);
    g.className = 'nx-zoom__img nx-zoom__img--ghost';
    g.removeAttribute('srcset');
    g.removeAttribute('sizes');
    g.alt = '';
    g.src = item.slide ? phoneSrc(item) : (item.preview || item.src);
    g.style.transform = 'translateX(' + dx + 'px)';
    frame.appendChild(g);
    return g;
  }
  function reel() {
    if (ghosts || !frame || list.length < 2 || !fitted()) return;
    var w = overlay.clientWidth;
    ghosts = { next: ghostFor(at + 1, w), prev: ghostFor(at - 1, -w) };
  }
  function dropReel() {
    if (!ghosts) return;
    if (ghosts.next.parentNode) ghosts.next.remove();
    if (ghosts.prev.parentNode) ghosts.prev.remove();
    ghosts = null;
  }
  /* ⚠ THE TRAVEL IS TIMED BY WHAT IS LEFT OF IT (owner, 2026-09-22: "не премиально резко, иногда
     два кадра"). It used to be a flat 220ms from wherever the finger let go — so a long flick,
     which has already dragged the picture nine tenths of the way across, played those 220ms over
     the last sliver and read as a jump rather than a gallery: the next photograph appeared to
     arrive without travelling. Now the duration is proportional to the distance still to cover,
     between 170 and 340ms, and the curve is the gentler one the rest of the store uses.
     A flick therefore FINISHES quickly (little is left) while a short drag is carried the whole
     way at a readable speed. */
  /* 2026-10-02 (owner: "резкая, плавно — одно уезжает, другое приезжает"): 260–440ms on an ease-out curve. */
  var SLIDE_MAX = 440;
  function slideMs(fromPx, toPx) {
    var w = overlay ? overlay.clientWidth || 1 : 1;
    var left = Math.min(w, Math.abs((toPx || 0) - (fromPx || 0)));
    return Math.max(260, Math.round(SLIDE_MAX * (left / w)));
  }
  function slide(px, animate, ms) {
    if (!frame) return;
    frame.style.transition = animate
      ? 'transform ' + (ms || SLIDE_MAX) + 'ms cubic-bezier(.22,.61,.36,1)'
      : 'none';
    frame.style.transform = px ? 'translateX(' + px + 'px)' : '';
  }

  function step(by) {
    if (!list.length || sliding) return;
    if (!frame || list.length < 2 || !fitted()) {
      at = (at + by + list.length) % list.length;
      show();
      return;
    }
    sliding = true;
    reel();
    var w = overlay.clientWidth;
    var ms = slideMs(0, w);
    slide(by > 0 ? -w : w, true, ms);
    setTimeout(function () {
      at = (at + by + list.length) % list.length;
      show();
      settle();
    }, ms + 20);
  }

  /* The picture that slid in is the neighbour's copy (the ghost); the frame's own picture has just been given its
     file. Letting go before that file is decoded showed the previous photograph for a frame, then the new one —
     the blink. The ghost stays on screen until the frame's picture can paint, at most half a second. */
  function settle() {
    var done = false;
    var finish = function () { if (done) return; done = true; dropReel(); slide(0, false); sliding = false; };
    if (img && img.decode) img.decode().then(finish, finish); else finish();
    setTimeout(finish, 500);
  }
  function dragTo(dx) {
    if (sliding) return;
    reel();
    slide(dx, false);
  }
  function dragEnd(dx, by) {
    if (sliding || !frame) return;
    if (by) {
      sliding = true;
      var w = overlay.clientWidth;
      var target = by > 0 ? -w : w;
      var ms = slideMs(dx, target);
      slide(target, true, ms);
      setTimeout(function () {
        at = (at + by + list.length) % list.length;
        show();
        settle();
      }, ms + 20);
      return;
    }
    /* the finger let go short of the threshold: the picture goes back, in its own time */
    var back = slideMs(dx, 0);
    slide(0, true, back);
    setTimeout(dropReel, back + 20);
  }

  /* The picture the page already holds goes up at once; the 2048px file
     replaces it when it has arrived, and only if the reader is still on
     that picture. Its size never depends on which file is up: below 990px
     the box is the screen's, on a desktop the height is (daytakt.css,
     GALLERY ZOOM). A new picture always opens at its fitted size. */
  var zoomVideo = null;
  function showVideo(item) {
    if (!frame) return;
    if (zoomVideo) { zoomVideo.pause(); zoomVideo.hidden = true; }
    frame.classList.remove('is-video', 'is-playing');
    if (!item || !item.video || !item.video.sources.length) return;

    if (!zoomVideo) {
      zoomVideo = document.createElement('video');
      zoomVideo.className = 'nx-zoom__video';
      zoomVideo.playsInline = true;
      zoomVideo.muted = true;
      zoomVideo.loop = true;
      zoomVideo.preload = 'none';
      zoomVideo.setAttribute('playsinline', '');
      zoomVideo.addEventListener('click', function (e) {
        e.stopPropagation();
        if (zoomVideo.paused) { var r = zoomVideo.play(); if (r && r.catch) r.catch(function () {}); }
        else zoomVideo.pause();
      });
      zoomVideo.addEventListener('play', function () { frame.classList.add('is-playing'); });
      zoomVideo.addEventListener('pause', function () { frame.classList.remove('is-playing'); });
      frame.appendChild(zoomVideo);
    }
    if (zoomVideo.dataset.nxSrc !== item.video.sources[0].src) {
      zoomVideo.dataset.nxSrc = item.video.sources[0].src;
      zoomVideo.innerHTML = '';
      item.video.sources.forEach(function (s) {
        var el = document.createElement('source');
        el.src = s.src;
        if (s.type) el.type = s.type;
        zoomVideo.appendChild(el);
      });
      zoomVideo.load();
    }
    zoomVideo.poster = item.video.poster || item.src;
    zoomVideo.hidden = false;
    frame.classList.add('is-video');
  }

  function show() {
    var item = list[at];
    if (!item) return;
    var mine = ++showing;
    resetZoom();
    frame.scrollLeft = 0;
    frame.scrollTop = 0;
    img.alt = item.alt || '';
    /* ⚠ A FILM IN THE OVERLAY IS STILL NOT A PLAYER (owner, 2026-09-24). Same element as the
       gallery's: no controls, our own mark, one tap to play and one to pause. It is built once and
       reused, paused and hidden the moment the reader pages away, so only the frame on screen ever
       holds a decoder. */
    showVideo(item);
    /* ⚠ ON A PHONE THE BIG FILE WAITS FOR A ZOOM (owner, 2026-10-02: "какая-то перерисовка лишняя"). The page's own copy is
       sharp at the fitted size, and the 2048px file swapped in a moment after the photo had arrived read as the photo
       being drawn again. It goes up when the reader enlarges (upgradeFull: the double tap, the pinch), where a sharper
       picture is what they asked for. A desktop's frame is bigger than the page's copy, so there it still goes up at once. */
    img.dataset.nxFull = '';
    var first = item.slide ? phoneSrc(item) : item.preview;
    if (first && first !== item.src) {
      img.src = first;
      img.dataset.nxFull = item.src;
      if (!fitted()) upgradeFull();
    } else {
      img.src = item.src;
    }
    if (item.slide) warmNeighbours();
    var many = list.length > 1;
    prevBtn.hidden = !many;
    nextBtn.hidden = !many;
    countEl.hidden = !many;
    sideBtns.forEach(function (b) { b.hidden = !many; });
    placeSides();
    if (many) {
      if (countEl.children.length !== list.length) {
        countEl.innerHTML = '';
        for (var m = 0; m < list.length; m++) countEl.appendChild(document.createElement('i'));
      }
      for (var k = 0; k < countEl.children.length; k++) countEl.children[k].className = k === at ? 'is-on' : '';
    }
    setCaption(item.alt || '');
    overlay.setAttribute('aria-label', 'Product image ' + (at + 1) + ' of ' + list.length);
  }

  /* ⚠ HALF THIS SCREEN IS EMPTY and the frame never says what it is showing. A square photograph
     on a 390x844 phone draws 374x374 and leaves 201px of black above it and 201px below (measured,
     2026-09-21). The frames already carry their own title — the media's alt is written
     "<product> — <title>", so "Bends to wake" is there to be printed and nothing has to be
     invented.
     ⚠ Only a real title. Frames uploaded without one carry a screen-reader description instead
     ("The power bank in natural brushed aluminum, alone on pale oak, seen from a low three-quarter
     angle"): true, useful to a reader who cannot see it, and nonsense printed under the picture it
     describes. Those frames stay silent — the space was empty anyway. Of the-curve's 15 frames 11
     have a title, the-pull's 14 have 9, the-slip's 19 have 10.
     ⚠ aria-hidden: the alt already says this to a screen reader, and printing it twice is noise. */
  function captionOf(alt) {
    var parts = String(alt || '').split(/\s+[—–]\s+/);
    return parts.length > 1 ? parts.slice(1).join(' — ').trim() : '';
  }

  function setCaption(alt) {
    if (!captionEl) return;
    var t = captionOf(alt);
    captionEl.textContent = t;
    captionEl.hidden = !t;
    placeCaption();
  }

  /* The caption sits above the PICTURE, not above the box that holds it: the box is the whole
     screen and the picture is centred inside it by object-fit. Anchored by its bottom, so a title
     that runs to two lines grows upward and never walks onto the photograph. */
  /* Each side zone is as wide as the dark beside the picture, worked out from the picture's own
     proportions rather than its box: a film hides the <img>, and its box is then 0 wide. Never under
     72px, so a picture that fills the width still leaves something to press. */
  function placeSides() {
    if (!overlay || !sideBtns.length) return;
    var ar = img && img.naturalWidth ? img.naturalWidth / img.naturalHeight : 1;
    var shown = frame && frame.classList.contains('is-video') && zoomVideo ? zoomVideo : img;
    var h = (shown && shown.offsetHeight) || overlay.clientHeight * 0.92;   /* offsetHeight: not the enlarged box */
    var w = overlay.clientWidth, drawn = Math.min(w * 0.96, h * ar);
    overlay.style.setProperty('--nx-zoom-side', Math.max(72, Math.round((w - drawn) / 2)) + 'px');
  }

  function placeCaption() {
    if (!captionEl || captionEl.hidden || !img) return;
    var r = img.getBoundingClientRect();
    if (!r.height || !img.naturalWidth) return;
    var ar = img.naturalWidth / img.naturalHeight;
    var drawn = Math.min(r.height, r.width / ar);
    captionEl.style.setProperty('--nx-zoom-half', Math.round(drawn / 2) + 'px');
  }

  function open(items, index) {
    if (!overlay) build();
    lastFocus = document.activeElement;
    list = items && items.length ? items : [];
    at = index > 0 ? index : 0;
    if (at > list.length - 1) at = 0;
    show();
    overlay.hidden = false;
    // Forced reflow, not requestAnimationFrame: rAF does not fire in a
    // context that is not producing frames, and the overlay would stay
    // transparent. Same lesson as the filter drawer.
    void overlay.offsetWidth;
    placeSides();   /* show() ran while the overlay was hidden and measured nothing */
    overlay.classList.add('is-open');
    /* ⚠ Remember where the page stood. Locking the scroll moved it: opening a photograph from the
       gallery strip at 4765px put the page back at 3959 (measured 2026-09-21), so closing landed the
       reader somewhere they had not been. And the sticky Add to cart kept standing over the
       photograph — the second button the owner saw. */
    if (scrollWas === null) scrollWas = window.scrollY;
    document.documentElement.classList.add('nxs-noscroll', 'nx-zoom-open');
    overlay.querySelector('.nx-zoom__x').focus({ preventScroll: true });
    if (!inHistory) {
      try { history.pushState({ nxZoom: true }, ''); inHistory = true; } catch (e) {}
    }
  }

  // fromHistory: Back already took the entry off; anything else takes it off here.
  function close(fromHistory) {
    if (!overlay || overlay.hidden) return;
    showing++;
    if (zoomVideo) { zoomVideo.pause(); }   /* nothing goes on playing behind a closed overlay */
    overlay.classList.remove('is-open');
    overlay.hidden = true;
    document.documentElement.classList.remove('nxs-noscroll', 'nx-zoom-open');
    if (scrollWas !== null) { window.scrollTo(0, scrollWas); scrollWas = null; }
    // the sticky bar's observer cannot see a scroll that was locked and restored
    document.dispatchEvent(new Event('nx:recheck-sticky'));
    /* ⚠ FOCUS GOES BACK QUIETLY AFTER A CLICK (owner, 2026-10-08: "рамка возникает ненужная"). Escape is a key, so the
       browser draws the focus ring on the picture the focus returns to, round a picture the reader clicked. Opened with
       the mouse or a finger, the picture takes the focus back without the ring (daytakt.css, data-nx-quiet-focus) until
       it loses it; opened with Enter or Space, the ring stays, because that reader steers by it. */
    if (lastFocus && lastFocus.focus) {
      if (openedBy !== 'key' && lastFocus.classList && lastFocus.classList.contains('nx-zoomable')) {
        var quiet = lastFocus;
        quiet.setAttribute('data-nx-quiet-focus', '');
        quiet.addEventListener('blur', function off() {
          quiet.removeAttribute('data-nx-quiet-focus');
          quiet.removeEventListener('blur', off);
        });
      }
      lastFocus.focus({ preventScroll: true });
    }
    if (inHistory && fromHistory !== true) {
      inHistory = false;
      history.back();
    }
  }

  // The biggest version the CDN will give us, so the labels are legible
  // rather than the 1000px the gallery asked for.
  function fullSize(src) {
    if (!src) return src;
    return src.replace(/([?&])width=\d+/, '$1width=2048');
  }

  function bind(el, items, indexOf) {
    if (!el || el.dataset.nxZoomBound) return;
    el.dataset.nxZoomBound = '1';
    el.classList.add('nx-zoomable');
    el.setAttribute('role', 'button');
    el.setAttribute('tabindex', '0');
    el.setAttribute('aria-label', 'Open image');
    // ⚠ Recorded HERE, not in open(): tapping a bound picture focuses it and the browser scrolls it
    // into view first, so by the time the overlay opens the page has already moved (779px from the
    // gallery strip, measured 2026-09-21) and closing would land somewhere the reader never was.
    el.addEventListener('pointerdown', function () { scrollWas = window.scrollY; openedBy = 'pointer'; }, { passive: true });
    var go = function (e) {
      /* ⚠ The main frame is one big zoom target, and the video now lives inside it — so a tap on
         the player (or on its controls) bubbled up here and opened the overlay instead of playing
         (owner, 2026-09-24). While a film is the frame on show, this box opens nothing. */
      if (e && e.target && e.target.closest && e.target.closest('video')) return;
      if (el.classList && el.classList.contains('is-video')) return;
      var current = items();
      if (!current.length) {
        // No list to page through — a single picture still opens.
        var i = el.querySelector('img') || el;
        current = [{ src: fullSize(i.currentSrc || i.src), alt: i.alt, preview: i.currentSrc || null }];
        return open(current, 0);
      }
      open(current, indexOf());
    };
    el.addEventListener('click', go);
    el.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        openedBy = 'key';
        go();
      }
    });
  }

  document.querySelectorAll('[id^="ProductHero-"]').forEach(function (hero) {
    /* The gallery's own list, read from the thumb strip — it already
       carries every media's full-size URL and alt, so the overlay does not
       need a second source of truth. Read at OPEN time, not at bind time:
       choosing a variant can swap the media set. */
    var items = function () {
      /* preview: the copy of that picture the page is already showing, if it
         has finished loading — the phone's carousel frame, or on a desktop the
         main image for the active thumb. */
      var phone = window.matchMedia('(max-width: 749px)').matches;
      var main = hero.querySelector('[data-nx-main-media] img');
      var out = [];
      hero.querySelectorAll('[data-nx-thumb]').forEach(function (t) {
        if (!t.dataset.fullSrc) return;
        /* ⚠ THE FILM BELONGS IN THE VIEWER TOO (owner, 2026-09-24), but as a film. Its
           `data-full-src` is only a poster, so carrying that alone put a photograph in the reel
           that could not be played and said nothing about itself. The sources are read from the
           <video> the section already printed for that media id, and the overlay plays them. */
        var vid = null;
        if (t.dataset.mediaType === 'video') {
          var el = hero.querySelector('[data-nx-main-video][data-media-id="' + t.dataset.mediaId + '"]')
            || hero.querySelector('.nx-product-hero__scroll-item[data-media-id="' + t.dataset.mediaId + '"] video');
          if (el) {
            vid = { poster: el.getAttribute('poster') || t.dataset.fullSrc, sources: [] };
            el.querySelectorAll('source').forEach(function (s) {
              vid.sources.push({ src: s.src, type: s.type });
            });
          }
        }
        var slide = hero.querySelector('.nx-product-hero__scroll-item[data-media-id="' + t.dataset.mediaId + '"] img');
        var shown = phone ? slide : (t.classList.contains('nx-product-hero__thumb--active') ? main : null);
        out.push({
          src: vid ? vid.poster : fullSize(t.dataset.fullSrc),
          alt: t.dataset.mediaAlt || '',
          preview: shown && shown.complete && shown.naturalWidth > 1 ? shown.currentSrc : null,
          /* the phone strip's own picture, read again whenever it is needed (phoneSrc): one that finished loading
             after the viewer opened is still the copy the reel shows */
          slide: phone && slide && !vid ? slide : null,
          video: vid
        });
      });
      return out;
    };
    var activeIndex = function () {
      var thumbs = hero.querySelectorAll('[data-nx-thumb]');
      for (var i = 0; i < thumbs.length; i++) {
        if (thumbs[i].classList.contains('nx-product-hero__thumb--active')) return i;
      }
      return 0;
    };

    bind(hero.querySelector('.nx-product-hero__main'), items, activeIndex);

    var slides = hero.querySelectorAll('.nx-product-hero__scroll-item');
    slides.forEach(function (slide, i) {
      /* A video slide is left unbound: the tap plays the film where it stands rather than opening
         the overlay. The overlay still carries it — a reader who swipes into it there gets the
         same tap and the same mark, never a player. */
      if (slide.classList.contains('nx-product-hero__scroll-item--video')) return;
      bind(slide, items, function () {
        return i;
      });
    });
  });

  /* ⚠ ONLY THE HERO'S GALLERY OPENS THE VIEWER (owner, 2026-10-01: "зум и просмотр галереи да, в следующих секциях
     нет"). From 2026-09-18 the photographs further down — features, Designed For, the story gallery and its captions, the
     banner, review photos — opened it too, after Clarity counted dead clicks on them; the owner turned that off. Those
     pictures answer nothing now, and Clarity may count those taps as dead again: that is the owner's trade, not a fault. */
})();

/* ==================================================================
   CUT AND OPEN — one control, two bands (2026-08-01)

   Why We Chose It: the reason runs 462px of 33px prose on a laptop and
   749px of section on a wide screen, which is a wall, and a wall gets
   skipped whole.

   Specifications: the owner asked for the same behaviour and gave the
   reason — you go to a spec sheet to look ONE thing up, so ten rows of
   answers to questions you did not ask is bulk, not information.

   Both are cut with a gradient into the band's own ground and opened by
   the same quiet chevron, so the page has one gesture rather than two
   dialects of the same idea.

   The control is only built when the content actually overflows the cut,
   so a short reason or a five-row spec table shows neither button nor
   fade. Opening animates to the measured height and is then released to
   `none`, so a later resize or font swap cannot leave the box a wrong
   fixed size.
   ================================================================== */
(function () {
  /* Three chevrons, not one (owner, 2026-08-02). A single arrow on a page
     you scroll reads as "scroll"; three stacked read as a direction of
     travel — the same reason a lift button has an arrow and a stairwell
     has a sign. They fade back as they descend and the animation walks
     down the stack rather than moving the whole group, so it beckons
     without bouncing. */
  var CHEVRON =
    '<svg class="nx-more__chevrons" viewBox="0 0 16 20" fill="none" aria-hidden="true">' +
    '<path class="nx-more__c1" d="M2 2l6 5.4L14 2" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>' +
    '<path class="nx-more__c2" d="M2 8.3l6 5.4 6-5.4" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>' +
    '<path class="nx-more__c3" d="M2 14.6l6 5.4 6-5.4" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>' +
    '</svg>';

  /* Measuring a band is a forced layout of the whole page, and three bands measuring in the same
     frame while the page was still loading cost 58 ms with a reader's tap waiting behind it
     (2026-09-16). Every band here is below the fold, so each waits until the reader is two screens
     away from it — which for most of them never comes: average scroll depth is 27%. */
  function whenNear(box, run) {
    if (!('IntersectionObserver' in window)) return run();
    var io = new IntersectionObserver(function (entries) {
      if (!entries[0].isIntersecting) return;
      io.disconnect();
      run();
    }, { rootMargin: '200% 0px' });
    io.observe(box);
  }

  /* box     the element that gets clipped
     more    the label when closed
     less    the label when open
     prepare optional, runs before the first measurement
     slack   how much has to be hidden before the control is worth it */
  function cutAndOpen(box, more, less, prepare, slack) {
    if (!box || box.dataset.nxCutBound === '1') return;
    box.dataset.nxCutBound = '1';

    var setup = function () {
      if (prepare) prepare(box);

      // Measure against the collapsed height rather than a line count: the
      // type is fluid, so the only honest question is "does it overflow".
      box.setAttribute('data-nx-collapsible', '');
      var collapsed = box.clientHeight;
      var full = box.scrollHeight;
      if (full <= collapsed + (slack || 8)) {
        box.removeAttribute('data-nx-collapsible');
        return;
      }

      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'nx-more';
      btn.setAttribute('aria-expanded', 'false');
      btn.innerHTML = '<span class="nx-more__t">' + more + '</span>' + CHEVRON;
      box.insertAdjacentElement('afterend', btn);

      var label = btn.querySelector('.nx-more__t');

      btn.addEventListener('click', function () {
        var open = box.hasAttribute('data-nx-open');
        if (open) {
          var collapse = function () {
            // From `none` back to a number, or the transition has nothing
            // to animate from.
            box.style.maxHeight = box.scrollHeight + 'px';
            void box.offsetHeight;
            box.removeAttribute('data-nx-open');
            box.style.maxHeight = '';
          };

          btn.setAttribute('aria-expanded', 'false');
          label.textContent = more;

          // Closing from the bottom of a long band leaves the reader in
          // the middle of something with nothing in it, so take them back
          // to its top — under the sticky header, not behind it.
          var band = box.closest('section') || box.parentElement;
          var header =
            parseInt(getComputedStyle(document.documentElement).getPropertyValue('--nx-header'), 10) || 98;
          var top = band.getBoundingClientRect().top + window.scrollY - header - 12;

          if (window.scrollY > top + 4) {
            // ⚠ Scroll FIRST and fold only once it lands. Doing both at
            // once jerked the page up and then dropped it, worst on a
            // phone: the band shrinks while it is partly ABOVE the
            // viewport, the browser's scroll anchoring compensates for
            // the content it just lost, and that correction fights the
            // smooth scroll still in flight. Sequenced, only one thing
            // moves at a time.
            var folded = false;
            var thenFold = function () {
              if (folded) return;
              folded = true;
              collapse();
            };
            if ('onscrollend' in window) window.addEventListener('scrollend', thenFold, { once: true });
            window.scrollTo({ top: top, behavior: 'smooth' });
            setTimeout(thenFold, 700); // fallback, and for browsers without scrollend
          } else {
            collapse();
          }
        } else {
          box.style.maxHeight = box.scrollHeight + 'px';
          box.setAttribute('data-nx-open', '');
          btn.setAttribute('aria-expanded', 'true');
          label.textContent = less;
          setTimeout(function () {
            if (box.hasAttribute('data-nx-open')) box.style.maxHeight = '';
          }, 600);
        }
      });

      /* ⚠ THE BLOCK OPENS ITSELF, not only the control under it. The button is a 53px strip
         BELOW the text, so it is 20% of the specifications block, 17% of why-we-chose-it and
         3% of the review band — and it sits where nobody is looking. In Clarity the owner
         watched people tap the text again and again and nothing happen (2026-09-21).
         ⚠ Opening only, never closing. Once a block is open it is full of prose someone is
         reading, and a tap that collapses what you are reading is worse than no close at all;
         the button keeps that job. */
      box.style.cursor = 'pointer';
      var down = null;
      box.addEventListener('pointerdown', function (e) { down = { x: e.clientX, y: e.clientY }; });
      box.addEventListener('click', function (e) {
        if (box.hasAttribute('data-nx-open')) return;
        if (e.target.closest && e.target.closest('a, button, input, select, textarea, label, summary')) return;
        // A drag is a scroll, not a tap — a phone reports both as a click at the end.
        if (down && (Math.abs(e.clientX - down.x) > 10 || Math.abs(e.clientY - down.y) > 10)) return;
        var sel = window.getSelection && window.getSelection();
        if (sel && String(sel).length > 0) return;
        btn.click();
      });

      /* Asked to open before it was ever measured: the hero's spec line sends the reader here from
         the first screen, long before this band is near enough to be set up (2026-09-28). */
      if (box.dataset.nxWantOpen === '1') {
        delete box.dataset.nxWantOpen;
        btn.click();
      }
    };

    // Fonts change the line count, so measure once they have settled — and not before the reader is
    // anywhere near the band (whenNear, above).
    whenNear(box, function () {
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(setup);
      else setup();
    });
  }

  // `data-nx-full` is the section's "Show the whole reason" setting: the Meta entrance prints
  // the statement whole, because that paragraph is what a cold visitor came to read.
  document.querySelectorAll('.nx-why-chosen__statement:not([data-nx-full])').forEach(function (statement) {
    cutAndOpen(statement, 'Read the whole reason', 'Less', function (box) {
      // The signature is the last line of the reason, not a caption under a
      // control — so it moves INSIDE the clipped box and appears with the
      // rest of the text. Left outside it sat below the chevron, which read
      // as the team signing the button rather than the paragraph.
      var inner = box.parentElement;
      var signature = inner && inner.querySelector('.nx-why-chosen__signature');
      if (signature && signature.parentElement !== box) box.appendChild(signature);
    });
  });

  /* The spec table's cut is measured, not guessed: the rows are a grid
     whose column count changes with the screen, so "four rows" means four
     VISUAL LINES, which is four facts on a phone and eight on a desktop.
     Reading their offsetTop is the only way to know where a line starts. */
  document.querySelectorAll('.nx-specs__fold').forEach(function (fold) {
    // Two lines, closed — the owner's measure: the band should be small
    // enough that a reader scrolls past it without deciding anything.
    var lines = 2;
    cutAndOpen(
      fold,
      'All specifications',
      'Less',
      function (box) {
        // ⚠ Not offsetTop. It is measured from the nearest POSITIONED
        // ancestor, which here is a wrapper near the top of the document,
        // so the fourth line reported 6588px and the cut was set to a
        // max-height twelve times the table's own height — no overflow, no
        // control, and the whole feature silently did nothing. Rects are
        // absolute, so the difference between two of them is the only
        // reliable answer.
        var base = box.getBoundingClientRect().top;
        var tops = [];
        [].forEach.call(box.querySelectorAll('.nx-specs__row'), function (row) {
          var t = Math.round(row.getBoundingClientRect().top - base);
          if (tops.indexOf(t) === -1) tops.push(t);
        });
        tops.sort(function (a, b) {
          return a - b;
        });
        if (tops.length > lines) box.style.setProperty('--nx-specs-cut', tops[lines] + 'px');
      },
      // A control that reveals one more line is a control not worth
      // having. 40px is a row and a bit at the tightened metrics.
      40
    );
  });

  /* ⚠ THE LABEL OVER A FOLDED TABLE IS ITS HEADER, and a header is tapped to open (2026-09-28).
     Clarity counted taps on "Specifications" and on the hero's spec line ("140W · 6 PORTS · DISPLAY")
     that answered nothing — two and three in a row in the recordings, readers looking for the numbers.
     The band's own label opens the fold it names; the hero's line takes the reader to the band and
     opens it on arrival. Neither looks any different: the taps were already there. Open only, never
     close — the chevron keeps that job, as it does for a tap on the table. */
  var specsFold = document.querySelector('.nx-specs__fold');
  if (specsFold) {
    var openSpecs = function () {
      var more = specsFold.nextElementSibling;
      if (more && more.classList.contains('nx-more')) {
        if (!specsFold.hasAttribute('data-nx-open')) more.click();
      } else {
        specsFold.dataset.nxWantOpen = '1';   // not set up yet: cutAndOpen opens it when it is
      }
    };
    var asLink = function (el, run) {
      el.style.cursor = 'pointer';
      el.setAttribute('role', 'button');
      el.setAttribute('tabindex', '0');
      el.addEventListener('click', run);
      el.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); run(); }
      });
    };

    var bandLabel = specsFold.previousElementSibling;
    if (bandLabel && bandLabel.classList.contains('nx-eyebrow')) asLink(bandLabel, openSpecs);

    var band = specsFold.closest('section') || specsFold;
    document.querySelectorAll('[id^="ProductHero-"] .nx-product-hero__panel > .nx-eyebrow').forEach(function (line) {
      asLink(line, function () {
        openSpecs();
        var header = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--nx-header'), 10) || 98;
        var target = function () { return band.getBoundingClientRect().top + window.scrollY - header - 12; };
        window.scrollTo({ top: target(), behavior: 'smooth' });
        /* Pictures between the hero and the band may still be arriving and move it while the page
           travels: land, then settle once on where the band actually is. */
        var settle = function () {
          if (Math.abs(target() - window.scrollY) > 24) window.scrollTo({ top: target() });
        };
        if ('onscrollend' in window) window.addEventListener('scrollend', settle, { once: true });
        else setTimeout(settle, 900);
      });
    });
  }

  /* Reviews on a phone (owner, 2026-09-15): one list, folded after three
     cards, each clamped to five lines while folded (nx-product-reviews.liquid),
     opened whole. The cut sits 64px under the third card, so the top of the
     fourth shows through the fade and the list reads as going on. The page
     is measured with every card showing: the pager above keeps them all on
     a phone. A desktop pages instead and never binds this. */
  document.querySelectorAll('[data-nx-reviews-track]').forEach(function (track) {
    if (!window.matchMedia('(max-width: 749px)').matches) return;
    if (track.hasAttribute('data-nx-reviews-swipe')) return; // one swipeable row folds nothing (Meta entrance)
    var cards = track.querySelectorAll('.nx-reviews__card');
    if (cards.length < 4) return;
    cutAndOpen(
      track,
      'All ' + cards.length + ' reviews',
      'Less',
      function (box) {
        var third = cards[2].getBoundingClientRect().bottom - box.getBoundingClientRect().top;
        box.style.setProperty('--nx-reviews-cut', Math.round(third + 64) + 'px');
      },
      40
    );
    /* A tap on a card while the list is folded opens it, through the same control (owner,
       2026-09-18). A folded review ends in "…" and readers tap it to read on: on the-curve a clamped
       review was the most tapped thing on the page, 9 of 79 taps in three days, and it answered
       nothing. Once open the cards are plain text again. */
    track.addEventListener('click', function (e) {
      if (!track.hasAttribute('data-nx-collapsible') || track.hasAttribute('data-nx-open')) return;
      if (!e.target.closest('.nx-reviews__card')) return;
      var more = track.nextElementSibling;
      if (more && more.classList.contains('nx-more')) more.click();
    });
  });
})();


/* ==================================================================
   OWNER REVIEWS BAND, phone (2026-09-15)

   The dots under the swiped quotes follow the swipe: the card nearest
   the track's scroll padding is the one lit. A single card prints no
   dots, so there is nothing to bind. Since 2026-10-06 the phone's band is
   two quotes stacked and prints no dots; this drives the desktop's strip
   after the hero instead — eight cards, three to a view, its arrows and
   dots (sections/nx-product-hero.liquid, .nx-product-hero__quotes--desk).
   ================================================================== */
(function () {
  document.querySelectorAll('[data-nx-quotes-track]').forEach(function (track) {
    var band = track.parentNode;
    var dots = band.querySelectorAll('[data-nx-quotes-dot]');
    var cards = track.querySelectorAll('.nx-product-hero__quotes-card');
    if (dots.length < 2 || !cards.length) return;
    var queued = false;
    /* one step is one card and the track's own gap — read, not assumed (28 on the old rail, 16 on the desktop's) */
    var stepW = function () { return cards[0] ? cards[0].getBoundingClientRect().width + (parseFloat(getComputedStyle(track).columnGap) || 0) : track.clientWidth; };
    function paint() {
      queued = false;
      var edge = track.getBoundingClientRect().left + (parseFloat(getComputedStyle(track).scrollPaddingLeft) || 0);
      var at = 0;
      var best = Infinity;
      for (var i = 0; i < cards.length; i++) {
        var d = Math.abs(cards[i].getBoundingClientRect().left - edge);
        if (d < best) { best = d; at = i; }
      }
      for (var k = 0; k < dots.length; k++) dots[k].classList.toggle('is-on', k === at);
    }
    /* ⚠ THE TRACK KEEPS ONE HEIGHT. It followed the quote being read for a day (2026-09-20) and the
       owner stopped it the next: a band that changes height under the thumb is worse than air under
       a short quote, and a fixed height on a scroller let the text be dragged up and down inside it.
       Equal heights, no inline height, and the track takes horizontal gestures only (daytakt.css). */
    track.addEventListener('scroll', function () {
      if (queued) return;
      queued = true;
      setTimeout(paint, 60);
    }, { passive: true });

    /* The arrows beside the marks move the rail by one card and stand down at its ends, so the
       control says what it can do before it is pressed (owner, 2026-09-21). */
    var steps = band.querySelectorAll('[data-nx-quotes-step]');
    if (steps.length) {
      var edges = function () {
        steps[0].disabled = track.scrollLeft <= 2;
        steps[1].disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 2;
      };
      [].forEach.call(steps, function (s) {
        s.addEventListener('click', function () {
          var by = Number(s.getAttribute('data-nx-quotes-step')) || 1;
          track.scrollBy({ left: by * stepW(), behavior: 'smooth' });
        });
      });
      track.addEventListener('scroll', function () { setTimeout(edges, 80); }, { passive: true });
      edges();
    }

    /* A sideways swipe anywhere on the band pages the quotes (owner, 2026-09-30): the label, the
       score and the dots around the track caught thumbs that then did nothing. The track keeps its
       own native swipe, so this hears only touches that begin outside it, and it never blocks the
       page's vertical scroll (passive, decided on lift). */
    var sx = 0, sy = 0, live = false;
    band.addEventListener('touchstart', function (e) {
      live = e.touches.length === 1 && !track.contains(e.target);
      if (live) { sx = e.touches[0].clientX; sy = e.touches[0].clientY; }
    }, { passive: true });
    band.addEventListener('touchend', function (e) {
      if (!live) return;
      live = false;
      var t = e.changedTouches[0];
      var dx = t.clientX - sx, dy = t.clientY - sy;
      if (Math.abs(dx) < 36 || Math.abs(dx) < Math.abs(dy) * 1.5) return;
      track.scrollBy({ left: (dx < 0 ? 1 : -1) * stepW(), behavior: 'smooth' });
    }, { passive: true });
  });
})();

/* The quotes and their label lead to the reviews (2026-09-28). The rating beside them always did;
   the quote itself and "What owners say" answered nothing, and on the-curve they took 4 of 98 taps,
   on the-mist 4 more (Clarity, 24–28.09). A swipe along the rail is not a tap: the rail is how the
   reader moves between quotes, and it must keep moving, not jump the page. */
(function () {
  var reviews = document.getElementById('nx-reviews');
  if (!reviews) return;
  /* ⚠ LAND, THEN SETTLE. The folded bands between here and the reviews set themselves up as the
     page travels past them and shrink by hundreds of pixels (the specifications, 864 → 118), so a
     smooth scroll aimed at the reviews from the first screen overshot them by 545px (measured
     2026-09-28). Once it lands, it goes to where the reviews actually are. */
  var margin = function () { return parseInt(getComputedStyle(reviews).scrollMarginTop, 10) || 0; };
  var go = function () {
    reviews.scrollIntoView({ behavior: 'smooth', block: 'start' });
    var settle = function () {
      if (Math.abs(reviews.getBoundingClientRect().top - margin()) > 24) reviews.scrollIntoView({ block: 'start' });
    };
    if ('onscrollend' in window) window.addEventListener('scrollend', settle, { once: true });
    else setTimeout(settle, 900);
  };
  document.querySelectorAll('.nx-product-hero__quotes').forEach(function (band) {
    /* "Read all N reviews" under the two quotes (owner, 2026-10-06): the same landing, not the hash's jump */
    var all = band.querySelector('.nx-product-hero__quotes-all');
    if (all) all.addEventListener('click', function (e) { e.preventDefault(); go(); });
    var label = band.querySelector('.nx-product-hero__quotes-eyebrow');
    if (label) {
      label.style.cursor = 'pointer';
      label.setAttribute('role', 'link');
      label.setAttribute('tabindex', '0');
      label.addEventListener('click', go);
      label.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') { e.preventDefault(); go(); }
      });
    }
    band.querySelectorAll('.nx-product-hero__quotes-card').forEach(function (card) {
      card.style.cursor = 'pointer';
      var down = null;
      card.addEventListener('pointerdown', function (e) { down = { x: e.clientX, y: e.clientY }; }, { passive: true });
      card.addEventListener('click', function (e) {
        if (down && (Math.abs(e.clientX - down.x) > 10 || Math.abs(e.clientY - down.y) > 10)) return;
        var sel = window.getSelection && window.getSelection();
        if (sel && String(sel).length > 0) return;
        go();
      });
    });
  });
})();

/* ==================================================================
   IN THIS STORY, phone (2026-09-15)

   The chapter buttons under "The short version" are printed by the
   hero, which cannot see the sections after it. Each names its chapter
   by class; here it gets that chapter's id as its href, or is removed
   when this page has no such chapter or the chapter renders nothing.
   ================================================================== */
nxIdle(function () {
  document.querySelectorAll('[data-nx-chapters]').forEach(function (nav) {
    /* Every chapter is measured first and the buttons are changed after, because `offsetHeight`
       between two removals is a fresh layout of the page each time: read-write-read-write across
       five chapters was 15 to 32 ms of the start-up (2026-09-16, CPU 4x). Even batched it was 22,
       because the first read is the page's first layout; in an idle slot the browser has laid the
       page out already and the same five reads cost about one. */
    var found = [];
    nav.querySelectorAll('[data-nx-chapter]').forEach(function (chip) {
      var chapter = document.querySelector(chip.getAttribute('data-nx-chapter'));
      found.push({ chip: chip, ok: !!(chapter && chapter.id && chapter.offsetHeight >= 40), id: chapter ? chapter.id : '' });
    });
    var kept = 0;
    found.forEach(function (row) {
      if (!row.ok) {
        row.chip.parentNode.removeChild(row.chip);
        return;
      }
      row.chip.setAttribute('href', '#' + row.id);
      kept += 1;
    });
    if (!kept) nav.parentNode.removeChild(nav);
  });
}, 800);

}

/* ==================================================================
   WHAT THE READER ACTUALLY REACHES (2026-09-20)

   Two questions we kept answering by argument: how far into the gallery a
   shopper swipes, and how far down the page anyone gets. Clarity gives one
   average for the whole site (27.6% over three days) and no per-section
   answer, so the page reports its own two numbers to GA4 (gtag is on every
   page, G-XZ4GBF2EGK).

   Both are sent ONCE, when the page is hidden or unloaded, so a reader who
   keeps swiping is counted at their deepest, not at their first move. A
   scroll listener only records a number; nothing is sent while reading.
   ⚠ Sent with sendBeacon through gtag's own transport - a normal request on
   pagehide is cancelled by the navigation and the event never lands.
   ================================================================== */
(function () {
  var hero = document.querySelector('.nx-product-hero');
  if (!hero) return;
  /* ⚠ gtag is NOT here yet when this runs. This file is deferred and Google's tag is injected by
     the Shopify app later, so an early `typeof window.gtag` test returned false on every load and
     nothing was ever reported. The tag is looked up at send time, and dataLayer takes it if the
     function still has not arrived. */
  function send(name, params) {
    if (typeof window.gtag === 'function') { window.gtag('event', name, params); return; }
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: name }, params));
  }
  var handle = (document.querySelector('link[rel="canonical"]') || {}).href || location.pathname;
  handle = handle.split('/products/').pop().split('?')[0];

  var strip = hero.querySelector('.nx-product-hero__scroller');
  var frames = hero.querySelectorAll('.nx-product-hero__scroll-item').length;
  var deepestFrame = 1;
  if (strip) {
    strip.addEventListener('scroll', function () {
      var i = Math.round(strip.scrollLeft / strip.clientWidth) + 1;
      if (i > deepestFrame) deepestFrame = i;
    }, { passive: true });
  }
  /* A thumb click on a laptop is the same act as a swipe on a phone. */
  hero.querySelectorAll('[data-nx-thumb]').forEach(function (thumb, i) {
    thumb.addEventListener('click', function () { if (i + 1 > deepestFrame) deepestFrame = i + 1; });
  });

  /* The page's own strips, named by the section they are: the deepest one
     whose top the reader has passed is what the page actually delivered. */
  var strips = [];
  document.querySelectorAll('[id^="shopify-section"]').forEach(function (el) {
    var name = el.id.replace(/^shopify-section-/, '').replace(/^template--\d+__/, '').replace(/^sections--\d+__/, '');
    if (el.offsetHeight > 120) strips.push({ name: name, el: el });
  });
  var deepestStrip = strips.length ? strips[0].name : '';
  var deepestPercent = 0;
  var ticking = false;
  function readDepth() {
    ticking = false;
    var bottom = window.scrollY + window.innerHeight;
    var percent = Math.round((bottom / document.documentElement.scrollHeight) * 100);
    if (percent > deepestPercent) deepestPercent = Math.min(100, percent);
    for (var i = 0; i < strips.length; i++) {
      if (strips[i].el.getBoundingClientRect().top + window.scrollY < bottom - 80) deepestStrip = strips[i].name;
    }
  }
  window.addEventListener('scroll', function () {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(readDepth);
  }, { passive: true });
  readDepth();

  var sent = false;
  function report() {
    if (sent) return;
    sent = true;
    send('nx_gallery_depth', { product: handle, frames_seen: deepestFrame, frames_total: frames });
    send('nx_page_depth', { product: handle, deepest_strip: deepestStrip, percent_scrolled: deepestPercent });
  }
  document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'hidden') report(); });
  window.addEventListener('pagehide', report);
})();

/* ==================================================================
   THE GROUNDS ALTERNATE AS RENDERED (2026-09-21)

   Two grounds, and they alternate (DESIGN_SYSTEM.md). The ground of each
   strip is written in daytakt.css for the page as it usually stands — but
   a product without reviews prints no review band and no reviews strip, and
   one without a story gallery prints no gallery, so the page that reaches
   the reader is not the page the list was written for and two identical
   grounds end up touching.

   ⚠ And a strip does not always end on the ground it declares: the hero is
   paper and finishes with a mist review band running edge to edge, so what
   the next strip meets is the BAND. The seam is measured, not assumed.
   ================================================================== */
(function () {
  if (!document.querySelector('.nx-product-hero')) return;
  var PAPER = 'nx-ground--paper';
  var MIST = 'nx-ground--mist';
  var strips = [];
  document.querySelectorAll('.shopify-section').forEach(function (s) {
    if (/__anno|__head|__foot/.test(s.id)) return;
    if (/banner|marquee|story/.test(s.className)) return;   // a photograph is not a ground
    if (s.getBoundingClientRect().height < 8) return;
    strips.push(s);
  });
  /* ⚠ Which ELEMENT paints the edge, not only which colour: the strips do not agree on where the
     ground lives — some paint the inner <section>, some a div inside it — so a class on the wrapper
     reaches only half of them. The painter is what gets repainted. */
  function painterAt(section, which) {
    var box = section.getBoundingClientRect();
    var el = section.firstElementChild || section;
    var found = { el: el, colour: getComputedStyle(el).backgroundColor };
    section.querySelectorAll('*').forEach(function (node) {
      var b = node.getBoundingClientRect();
      if (b.width < box.width * 0.9 || b.height < 8) return;
      var touches = which === 'top' ? Math.abs(b.top - box.top) <= 2 : Math.abs(b.bottom - box.bottom) <= 2;
      if (!touches) return;
      var c = getComputedStyle(node).backgroundColor;
      if (c && c !== 'rgba(0, 0, 0, 0)') found = { el: node, colour: c };
    });
    return found;
  }
  // the two grounds, read from the tokens rather than written as numbers here
  var probe = document.createElement('div');
  probe.style.cssText = 'position:absolute;left:-9999px;width:1px;height:1px';
  document.body.appendChild(probe);
  var tone = function (token) { probe.style.background = 'var(' + token + ')'; return getComputedStyle(probe).backgroundColor; };
  var paper = tone('--nx-paper');
  var mist = tone('--nx-mist');
  probe.remove();

  var prevFoot = null;
  strips.forEach(function (s) {
    var top = painterAt(s, 'top');
    if (prevFoot && top.colour === prevFoot && (top.colour === paper || top.colour === mist)) {
      var want = top.colour === paper ? mist : paper;
      var foot = painterAt(s, 'bottom');
      top.el.style.background = want;
      if (foot.el !== top.el && foot.colour === top.colour) foot.el.style.background = want;
      s.classList.add(want === paper ? PAPER : MIST);
    }
    // read the foot AFTER any repaint: a strip that was flipped ends on its new ground
    prevFoot = painterAt(s, 'bottom').colour;
  });
})();
